




































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { MESSAGE } from "@/model/Message";
import { InspectItem } from "@/model/InspectItem";
import { Getter, Action } from "vuex-class";
import {
  Buhin,
  BuhinCategory,
  SubBuhinCategory,
  BuhinDetail
} from "@/model/Buhin";
import requestService from "@/service/requestService";
import { Utils } from "@/service/util";
import { Work } from "@/model/Work";
import { STATUS_SELECT_WORK_BUHIN } from "@/model/StatusSelectWorkBuhin";
import { InspectService } from "@/service/inspectService";
import InputNumber from "@/components/common/input/InputNumber.vue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { INSPECT_TYPE } from "@/model/InspectType";
import { InspectDescriptions } from "@/model/InspectGensha";
import { CarSelectData } from "@/model/CarSelection";
import ReservationDetailState from "@/store/reservation/state";
import KatashikiDialog from "@/components/KatashikiDialog.vue";
import NisseirenJunseiSearchDialog from "@/components/NisseirenJunseiSearchDialog.vue";
import KatashikiService from "@/service/KatashikiService";
import ExtendsImageDialog from "@/components/ExtendsImageDialog.vue";
import { ExtendsImageService } from "@/service/ExtendsImageService";
import { ExtendsImageInspectVO } from "@/model/ExtendsImage";
import {
  InspectLineWorkAndBuhinData,
  InspectWorkAndBuhinData,
  JizenRecommendWorkAndBuhinData,
  PartSelectionInspectWorkAndBuhinData,
  PartSelectionRecommendWorkAndBuhinData,
  RecommendWorkAndBuhinData,
  WORK_AND_BUHIN_MODE,
  WorkAndBuhinData,
  WorkAndBuhinMode,
  WorkAndBuhinRuntimeData
} from "@/model/WorkAndBuhinData";
import { WorkAndBuhinDataService } from "@/model/WorkAndBuhinDataService";
import {
  createInspectLineWorkAndBuhinDataService,
  createInspectWorkAndBuhinDataService,
  createJizenRecommendWorkAndBuhinDataService,
  createNoneWorkAndBuhinDataService,
  createPartSelectionInspectWorkAndBuhinDataService,
  createPartSelectionRecommendWorkAndBuhinDataService,
  createRecommendWorkAndBuhinDataService
} from "@/service/createWorkAndBuhinDataService";

// refactor : 現状はmodel式。serviceにはなっていない
import * as WorkBuhinAdapter from "@/components/work-buhin/WorkBuhinAdapter";
import * as WorkBuhinSelection from "@/components/work-buhin/WorkBuhinSelection";
import * as WorkBuhinVehicleDisplay from "@/components/work-buhin/WorkBuhinVehicleDisplay";
import * as WorkBuhinSave from "@/components/work-buhin/WorkBuhinSave";
import * as WorkBuhinMatch from "@/components/work-buhin/WorkBuhinMatch";
import * as WorkBuhinChange from "@/components/work-buhin/WorkBuhinChange";
import * as WorkBuhinQuantity from "@/components/work-buhin/WorkBuhinQuantity";
import * as WorkBuhinDisplay from "@/components/work-buhin/WorkBuhinDisplay";
import * as WorkBuhinManual from "@/components/work-buhin/WorkBuhinManual";
import * as WorkBuhinManualWork from "@/components/work-buhin/WorkBuhinManualWork";
import * as WorkBuhinNisseiren from "@/components/work-buhin/WorkBuhinNisseiren";
import * as WorkBuhinNisseirenApi from "@/components/work-buhin/WorkBuhinNisseirenApi";
import * as WorkBuhinConfirm from "@/components/work-buhin/WorkBuhinConfirm";
import * as WorkBuhinWorkSelection from "@/components/work-buhin/WorkBuhinWorkSelection";
import * as WorkBuhinButton from "@/components/work-buhin/WorkBuhinButton";
import * as WorkBuhinReset from "@/components/work-buhin/WorkBuhinReset";
import * as WorkBuhinDelete from "@/components/work-buhin/WorkBuhinDelete";
import * as WorkBuhinEdit from "@/components/work-buhin/WorkBuhinEdit";
import * as WorkBuhinClose from "@/components/work-buhin/WorkBuhinClose";
import * as WorkBuhinExtendsImage from "@/components/work-buhin/WorkBuhinExtendsImage";
import * as WorkBuhinPublicApi from "@/components/work-buhin/WorkBuhinPublicApi";
import * as WorkBuhinInit from "@/components/work-buhin/WorkBuhinInit";
import * as WorkBuhinTab from "@/components/work-buhin/WorkBuhinTab";


@Component({
  components: {
    InputNumber,
    ConfirmDialog,
    KatashikiDialog,
    NisseirenJunseiSearchDialog,
    ExtendsImageDialog
  }
})
export default class WorkAndBuhin extends Vue {
  @Prop({ default: {} })
  data!: WorkAndBuhinData;
  @Prop({ default: WORK_AND_BUHIN_MODE.NONE })
  mode!: WorkAndBuhinMode;
  @Prop({ default: true })
  editSeibi!: boolean;
  // 作業編集可否とは独立して日整連・純正部品を非表示にする。
  @Prop({ default: false })
  hideNisseirenJunsei!: boolean;
  @Prop({ default: true })
  showTitle!: boolean;
  @Prop({ default: true })
  closeBtn!: boolean;
  @Prop({ default: true })
  isDialog!: boolean;
  @Prop({ default: false })
  confirmBusy!: boolean;

  // 選択リストを空にしてから遅延復元する間は確定を受け付けない。
  buhinRestoreCount: number = 0;

  isBuhinConfirmBusy() {
    return this.confirmBusy || this.buhinRestoreCount > 0;
  }

  @Prop({ default: false })
  editResult!: boolean;

  @Getter("buhin", { namespace: "Buhin" })
  listBuhinData: Buhin[];

  @Getter("katashiki", { namespace: "CarSelection" })
  katashiki: string;

  @Getter("engineKatashiki", { namespace: "CarSelection" })
  engineKatashiki: string;

  @Action("setNisseirenWorkStoreByKatashiki", { namespace: "NisseirenWorkBuhin" })
  setNisseirenWorkStoreByKatashiki: any;

  @Getter("getNisseirenWorkStoreByKatashiki", { namespace: "NisseirenWorkBuhin" })
  getNisseirenWorkStoreByKatashiki: (arrayKeys: Array<string | number>) => any;

  @Action("setJunseiBuhinStoreByKatashiki", { namespace: "NisseirenWorkBuhin" })
  setJunseiBuhinStoreByKatashiki: any;

  @Getter("getJunseiBuhinStoreByKatashiki", { namespace: "NisseirenWorkBuhin" })
  getJunseiBuhinStoreByKatashiki: (arrayKeys: string[]) => any;

  @Action("setState", { namespace: "Buhin" })
  saveBuhin: (payload: Buhin[]) => void;

  @Getter("currentState", { namespace: "ReservationDetail" })
  currentState: ReservationDetailState;

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;

  @Getter("currentState", { namespace: "CarSelection" })
  carSelection: CarSelectData;

  @Getter("isExist", { namespace: "SeibiIds" })
  isSeibiExist!: (seibiDetailId: number, type: number) => boolean;

  @Getter("isSeibiDetailIdExist", { namespace: "SeibiIds" })
  isSeibiDetailIdExist!: (payload: any) => boolean;

  @Getter("seibiMenuCd", { namespace: "InspectionDetail" })
  seibiMenuCd: string;

  @Action("add", { namespace: "SeibiIds" })
  addSeibiId: any;

  @Action("remove", { namespace: "SeibiIds" })
  removeSeibiId: any;

  @Action("updateMakerModel", { namespace: "ReservationDetail" })
  updateMakerModel: any;

  // ネクステージだとisNextageCustom=trueになる設定値のロード。F5で消えるバグがあるがの直す予定。車検開始画面から遷移しなおすと再度動きます
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;

  @Getter("isUseNisseiren", { namespace: "FunctionSetting" })
  isUseNisseiren: number; // 日整連･純正部品使用フラグ（0：使用しない 1：日整連のみ 2：日整連・純正部品）

  @Getter("freeOfChargeLabelMini", { namespace: "FunctionSetting" })
  freeOfChargeLabel: any;

  @Getter("isCanExtendsImage", { namespace: "FunctionSetting" })
  isCanExtendsImage: any;

  isModeModal: boolean = false;
  listSelectedBuhin: any = [];
  listBuhinActiveSeibi: BuhinDetail[] = [];
  listManualBuhin: BuhinDetail[] = [];
  listManualBuhinFiltered: BuhinDetail[] = [];
  listManualBuhinName: string = "手入力";
  activeBuhinCateIndex: number = -1;
  sliderValue: number = 0;
  allowCustomerSelect: boolean = false;
  manualWorkNm: string = "";
  manualBuhinNm: string = "";
  manualKousuu: number | null = null;
  buhinCategory: BuhinCategory[] = [];
  buhinContent: SubBuhinCategory[] = [];
  activeCateBuhins: SubBuhinCategory[] = [];
  selFilter: any[] = [];
  disabledBtnConfirm: boolean = true;
  disabledBtnNoBuhin: boolean = true;
  activeWorkIndex: number = -1;
  isManualWork: boolean = false;
  activeBuhinShubetsuId: number = 0;
  inspectService: InspectService;
  reqService: requestService;
  katashikiService: KatashikiService;
  workAndBuhinDataService: WorkAndBuhinDataService;
  hasKatashiki: boolean = false;
  showKatashiki: string = "";
  showEngineKatashiki: string = "";
  showKakyuki: string = "";
  showModelNm: string = "";
  loadingBuhin: boolean = false;
  isChange: boolean = false;
  isResetSeibi: boolean = false;

  defualtBuhinShubetsuIndex: number = -1;
  defualtBuhinShubetsuCd: string = "";
  defualtBuhinBunruiCdList: string[];
  confirmMsg: string = "";
  showConfirmDialog: boolean = false;
  showConfirmDialog2: boolean = false;
  isBuhin: boolean = false; // Confirm buhin & no buhin
  listBuhinConfirm: any = {};
  activeSeibiId: number | null = 0;
  activeSeibiNm: string = "";
  isKouchinChange: boolean = false;

  $refs!: {
    askAddDialog: ConfirmDialog;
    askDeleteDialog: ConfirmDialog;
    katashikiDialog: KatashikiDialog;
    nisseirenJunseiSearchDialog: NisseirenJunseiSearchDialog;
  };

  tmpResetWorkIndex: number = -1;
  tmpDeleteWorkIndex: number = -1;
  tmpDeletedBuhin: any = null;
  tmpDeletedManualBuhinBuff: any = [];// 削除済みリスト
  tmpDeletedManualBuhinList: any = [];// 削除後確定済みリスト

  osusumeBuhinList: any = [];
  showBuhin: boolean = true;
  buhinTankaPlaceHolder: string = "単価(税抜)を入力してください";
  buhinChangeList: any = {};
  workBeforeChange: any = null;
  isSocket: boolean = false;
  isBuhinError: boolean = false;
  workConfirm: any = {};
  hasExplicitBuhinEdit: boolean = false;
  hasPendingBuhinEdit: boolean = false;
  firstBuhinCd: any = null;
  nRetryScroll = 0;
  freeOfChargeBuhinList: any = [];
  isDiscount: boolean = false;
  loading: boolean = false;
  loadingText: string = MESSAGE.Loading;

  extendsImageService: ExtendsImageService = new ExtendsImageService();
  extendsImageInspect: ExtendsImageInspectVO | null = null;
  showExtendsImageDialog: boolean = false;
  workBuhinContext: WorkBuhinAdapter.WorkBuhinInputContext | null = null;

  // バッテリー自動判定
  batteryFreeKwd: string = "";
  batteryCardOpened: boolean = true;
  batteryKeywordsBtn: any = [
    {label:"一般車用", type: 1 ,tips:[
      {tag: "B19", value: 0 },
      {tag: "B24", value: 0 },
      {tag: "D23", value: 0 },
      {tag: "D26", value: 0 },
      {tag: "D31", value: 0 },
      {tag: "E41", value: 0 },
      {tag: "F51", value: 0 },
      {tag: "G51", value: 0 },
      {tag: "H52", value: 0 }
    ]},
    {label:"アイドリングストップ専用", type: 1 ,tips:[
      {tag: "M42", value: 0 },
      {tag: "K42", value: 0 },
      {tag: "N55", value: 0 },
      {tag: "Q85", value: 0 },
      {tag: "S95", value: 0 },
      {tag: "T110", value: 0 }
    ]},
    {label:"VRLA(HV車補機用)", type: 1 ,tips:[
      {tag: "S46B24", value: 0 },
      {tag: "S34B20", value: 0 }
    ]},
    {label:"EN規格", type: 2 ,tips:[
      {tag: "LNシリーズ", value: 0 }
    ]},
    {label:"端子位置", type: 0 ,tips:[
      {tag: "L", value: 0 },
      {tag: "R", value: 0 }
    ]},
  ];
  batteryWarnNonKey: boolean = false;
  batteryWarnNonBase: boolean = false;
  batteryWarnNonCold: boolean = false;
  batteryWarnDoubleSet: boolean = false;
  batteryConvertFlg: boolean = false;

  public utils: Utils = new Utils();

  /**
   * 用途: data 差し替え時に service の参照とバッテリー初期表示を更新する。
   * WHY: 選択切替・再読込後の保存対象を最新 data に揃え、推奨バッテリーの初期絞り込みも再実行するため。
   */
  @Watch("data")
  onDataChanged() {
    this.setWorkAndBuhinDataService(this.mode);
    this.workBuhinContext = null;
    this.resetBatteryInitialDisplayState();
  }

  /**
   * 用途: 点検明細ID変更時に日整連/画像連携を再読込する。
   * WHY: data watcher の副作用入口を明示するため。
   */
  @Watch("data.sknInspectDescriptionId")
  onChangeDescriptionId() {
    this.getNisseirenJunseiByKatashiki();
    this.getExtendsImageInspect();
  }

  /**
   * 用途: WorkAndBuhin呼び出し元の親から渡された this.data の型を this.modeから類推、明示固定化する
   * WHY: 既存の関数説明を block comment 形式に揃えるため。
   */
  setWorkAndBuhinDataService(mode: WorkAndBuhinMode) {
    switch (mode) {
      case WORK_AND_BUHIN_MODE.NONE:
        this.workAndBuhinDataService =
          createNoneWorkAndBuhinDataService(this.data);
        break;
      case WORK_AND_BUHIN_MODE.INSPECT:
        // 通常点検選択（事前見積・現車・57点検）
        this.workAndBuhinDataService =
          createInspectWorkAndBuhinDataService(
            this.data as InspectWorkAndBuhinData
          );
        break;
      case WORK_AND_BUHIN_MODE.JIZEN_RECOMMEND:
        // 通常点検選択（事前見積のおすすめ整備）
        this.workAndBuhinDataService =
          createJizenRecommendWorkAndBuhinDataService(
            this.data as JizenRecommendWorkAndBuhinData
          );
        break;
      case WORK_AND_BUHIN_MODE.INSPECT_LINE:
        // 検査ライン連携からの呼び出し
        this.workAndBuhinDataService =
          createInspectLineWorkAndBuhinDataService(
            this.data as InspectLineWorkAndBuhinData
          );
        break;
      case WORK_AND_BUHIN_MODE.RECOMMEND:
        // おすすめ整備からの呼び出し
        this.workAndBuhinDataService =
          createRecommendWorkAndBuhinDataService(
            this.data as RecommendWorkAndBuhinData
          );
        break;
      case WORK_AND_BUHIN_MODE.PART_SELECTION_INSPECT:
        // 作業/部品選択からの呼び出し
        this.workAndBuhinDataService =
          createPartSelectionInspectWorkAndBuhinDataService(
            this.data as PartSelectionInspectWorkAndBuhinData
          );
        break;
      case WORK_AND_BUHIN_MODE.PART_SELECTION_RECOMMEND:
        // 作業/部品選択からの呼び出し（おすすめ整備）
        this.workAndBuhinDataService =
          createPartSelectionRecommendWorkAndBuhinDataService(
            this.data as PartSelectionRecommendWorkAndBuhinData
          );
        break;
    }
  }

  /**
   * 用途: WorkAndBuhin の初期 state と service を生成する。
   * WHY: lifecycle 起点の API/表示初期化順を固定するため。
   */
  created() {
    this.setWorkAndBuhinDataService(this.mode);
    this.resetBatteryInitialDisplayState();
    this.inspectService = new InspectService();
    this.reqService = new requestService();
    this.katashikiService = new KatashikiService();
    let katashikiParams = this.katashikiService.getKatashikiParams();
    const katashikiState = WorkBuhinInit.resolveCreatedKatashikiState({
      katashikiParams,
      uketsukeExtendsId: this.uketsukeExtendsId
    });
    const katashikiEffectState = WorkBuhinInit.buildCreatedKatashikiApplyEffectState(katashikiState);
    this.hasKatashiki = katashikiEffectState.hasKatashiki;
    if (!katashikiEffectState.hasKatashiki) {
      // 型式の詳細が不明な場合は検索する（完了を待たずに初期化を続ける）
      if (katashikiEffectState.shouldSearchKatashiki) {
        this.searchKatashiki();
      }
      if (katashikiEffectState.shouldClearKatashikiState) {
        this.katashikiService.clearState();
      }
    }
    if (katashikiEffectState.shouldLoadExtendsImageInspect) {
      this.getExtendsImageInspect();
    }
    if (katashikiEffectState.shouldUpdateKatashikiDisplay) {
      this.updateShowKatashiki();
      this.updateShowEngineKatashiki();
      this.updateShowKakyuki();
      this.updateShowModelNm();
    }
    const disableSaveTarget = this.workAndBuhinDataService.resolveCreatedDisableSaveTarget();
    if (disableSaveTarget) {
      this.initSeibiDisableSave(disableSaveTarget);
    }
    const confirmRestoreAction = this.workAndBuhinDataService
      .buildCreatedConfirmRestoreAction(this.isDialog);
    const confirmRestoreEffectState = WorkBuhinInit.buildCreatedConfirmRestoreEffectState(
      confirmRestoreAction
    );
    if (confirmRestoreEffectState.shouldKeepBuhinConfirm) {
      this.keepBuhinConfirm(confirmRestoreEffectState.seibiList);
      this.keepBuhinConfirm(confirmRestoreEffectState.manualSeibiList);
    } else if (confirmRestoreEffectState.shouldKeepBuhinConfirmOsusume) {
      this.keepBuhinConfirmOsusume(
        confirmRestoreEffectState.osusumeData,
        confirmRestoreEffectState.isInit
      );
    }
    let promise;
    const buhinMasterLoadState = WorkBuhinInit.buildCreatedBuhinMasterLoadActionState(
      this.listBuhinData
    );
    const buhinMasterLoadEffectState = WorkBuhinInit.buildCreatedBuhinMasterLoadApplyEffectState(
      buhinMasterLoadState
    );
    if (buhinMasterLoadEffectState.shouldRequestBuhinMaster) {
      // 部品データが無い場合は検索する
      if (buhinMasterLoadEffectState.shouldSetLoadingBuhin) {
        this.loadingBuhin = true;
      }
      // 現状部品棚コード'30003'(純正部品)の領域は未使用で、this.katashiki,this.enginekatashikiでの検索結果も未使用
      promise = this.reqService.getPartSelectionBuhin(
        this.uketsukeExtendsId,
        this.katashiki,
        this.engineKatashiki
      ).then(
        (res: Buhin[]) => {
          const buhinMasterApplyState = WorkBuhinInit.buildCreatedBuhinMasterResponseApplyState(res);
          const buhinMasterEffectState = WorkBuhinInit.buildCreatedBuhinMasterResponseApplyEffectState(
            buhinMasterApplyState
          );
          if (buhinMasterEffectState.shouldApplyBuhinMaster) {
            this.saveBuhin(buhinMasterEffectState.buhinMaster);
          }
          if (buhinMasterEffectState.shouldSetBuhinCate) {
            this.setBuhinCate();
          }
        },
        (error: any) => {
          const buhinMasterErrorEffectState = WorkBuhinInit.buildCreatedBuhinMasterErrorApplyEffectState();
          this.isBuhinError = buhinMasterErrorEffectState.isBuhinError;
          if (buhinMasterErrorEffectState.shouldHideBuhin) {
            this.hideBuhin();
          }
        }
      ).then(() => {
        const buhinMasterFinallyEffectState = WorkBuhinInit.buildCreatedBuhinMasterFinallyApplyEffectState();
        this.loadingBuhin = buhinMasterFinallyEffectState.loadingBuhin;
      });

    } else if (buhinMasterLoadEffectState.shouldUseCachedBuhinMaster) {
      // 部品データがある場合
      this.setBuhinCate();
    }
    Promise.all([promise]).then(() => {
      const nisseirenLoadEffectState = WorkBuhinInit.buildCreatedNisseirenLoadEffectState({
        hasKatashiki: this.hasKatashiki,
        isUseNisseiren: this.isUseNisseiren,
        hideNisseirenJunsei: this.hideNisseirenJunsei
      });
      if (nisseirenLoadEffectState.shouldLoadNisseirenJunsei) {
        this.getNisseirenJunseiByKatashiki();
      }
    });
  }

  /**
   * 用途: component 破棄時に画像連携購読を解除する。
   * WHY: lifecycle 外の購読解除漏れを防ぐため。
   */
  beforeDestroy() {
    this.extendsImageService.destroy(); // ソケット切断
  }

  /**
   * 用途: 点検結果に応じた表示 class を返す。
   * WHY: template に status 判定を直接書かず既存表示契約を維持するため。
   */
  inspectResClass() {
    return this.inspectService.inspectResClass(
      this.workAndBuhinDataService.getInspectResult(),
      this.workAndBuhinDataService.getSknInspectType()
    );
  }

  /**
   * 用途: 既存名で runtime data を参照する公開互換 facade。
   * WHY: data service 移行後も template/ref 側の参照名を維持するため。
   */
  get workAndBuhinData(): WorkAndBuhinRuntimeData {
    return this.workAndBuhinDataService.getInputData();
  }

  /**
   * 用途: inspect description として扱える data を返す。
   * WHY: mode 差異を data service 側に隠すため。
   */
  get inspectDescriptionWorkAndBuhinData(): InspectDescriptions {
    return this.workAndBuhinDataService.getInspectDescriptionData();
  }
  /**
   * 用途: dataが取りうる型、ここまで
   * WHY: 既存の関数説明を block comment 形式に揃えるため。
   */

  getWorkBuhinSourceMode(data?: any) {
    return this.workAndBuhinDataService.getWorkBuhinSourceMode(this.editSeibi, data);
  }

  buildWorkBuhinContext(
    data?: any
  ): WorkBuhinAdapter.WorkBuhinInputContext {
    return this.workAndBuhinDataService.buildWorkBuhinContext({
      data,
      editSeibi: this.editSeibi,
      activeWorkIndex: this.activeWorkIndex,
      isManualWork: this.isManualWork
    });
  }

  refreshWorkBuhinContext(
    data?: any
  ): WorkBuhinAdapter.WorkBuhinInputContext {
    const context = this.buildWorkBuhinContext(data);
    const updateState = this.workAndBuhinDataService
      .buildWorkBuhinContextUpdateState(data);
    if (updateState.shouldUpdateStoredContext) {
      this.workBuhinContext = context;
    }
    return context;
  }

  /**
   * 用途: 部品カテゴリと初期表示用の部品棚を設定する。
   * WHY: マスタ取得後の表示 state 反映を一箇所にまとめるため。
   */
  setBuhinCate() {
    if (this.listBuhinData.length > 0) {
      // 部品棚「その他管理部品」の部品種別タブ一覧を取得
      this.buhinCategory = this.utils.deepCopy(WorkBuhinInit.getLatestBuhinCategory(this.listBuhinData));
      const context = this.refreshWorkBuhinContext();
      const effectState = this.workAndBuhinDataService.buildSetBuhinCateEffectState({
        context,
        editSeibi: this.editSeibi
      });
      const filteredNormalBuhinApplyState = WorkBuhinInit.buildSetBuhinCateFilteredNormalBuhinApplyState(
        effectState
      );
      if (filteredNormalBuhinApplyState.shouldApply) {
        filteredNormalBuhinApplyState.normalWorkTarget.buhinList =
          filteredNormalBuhinApplyState.filteredNormalBuhinList;
      }
      if (effectState.shouldSelectWork) {
        const selectWorkEffectState = WorkBuhinInit.buildSetBuhinCateSelectWorkEffectState(
          effectState
        );
        const work = selectWorkEffectState.shouldDeepCopySelectWork
          ? this.utils.deepCopy(selectWorkEffectState.selectWork)
          : selectWorkEffectState.selectWork;
        this.onSelectWork(
          work,
          selectWorkEffectState.selectWorkIndex,
          selectWorkEffectState.selectWorkIsManual,
          selectWorkEffectState.forceSelectWork
        );
      } else if (effectState.shouldSetRecommendSelectionState) {
        // おすすめ整備データには作業配列がないため、明示的に選択状態を作る
        const recommendSelectionEffectState = WorkBuhinInit.buildSetBuhinCateRecommendSelectionEffectState(
          effectState
        );
        this.activeWorkIndex = recommendSelectionEffectState.activeWorkIndex;
        this.isManualWork = recommendSelectionEffectState.isManualWork;
        if (recommendSelectionEffectState.shouldInitListSelectedBuhin) {
          this.initListSelectedBuhin(recommendSelectionEffectState.initListSelectedBuhinWork);
        }
        if (recommendSelectionEffectState.shouldSetOsusumeBuhinList) {
          this.osusumeBuhinList = recommendSelectionEffectState.osusumeBuhinList;
        }
        if (recommendSelectionEffectState.shouldSelectOsusumeTab) {
          this.onSelectOsusumeTab();
        } else if (recommendSelectionEffectState.shouldSelectBuhinShubetsu) {
          this.selectBuhinShubetsu(
            recommendSelectionEffectState.buhinShubetsuCd,
            recommendSelectionEffectState.buhinBunruiList
          );
        }
      } else if (effectState.shouldKeepBuhinMd15WithDelay) {
        setTimeout(() => {
          const delayedKeepMd15EffectState = WorkBuhinInit.buildSetBuhinCateDelayedKeepMd15EffectState(
            effectState
          );
          if (delayedKeepMd15EffectState.shouldKeepBuhinMd15) {
            this.onkeepBuhinMD15();
          }
        }, effectState.keepBuhinMd15DelayMs);
      }
    }
  }

  /**
   * 用途: filterActive で表示対象の部品/作業を絞り込む。
   * WHY: template の一覧表示条件を component method に閉じ込めるため。
   */
  filterActive(cd: string) {
    return WorkBuhinDisplay.buildBuhinFilterActiveState(this.selFilter, cd).isActive;
  }

  /**
   * 用途: checkDisabledBtnConfirm で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  checkDisabledBtnConfirm(work?: Work) {
    const disabledState = this.workAndBuhinDataService.resolveWorkBuhinButtonDisabledState({
      work,
      isManualWork: this.isManualWork,
      activeWorkIndex: this.activeWorkIndex,
      listSelectedBuhin: this.listSelectedBuhin,
      listManualBuhin: this.listManualBuhin
    });
    this.$set(this, "disabledBtnNoBuhin", disabledState.disabledBtnNoBuhin);
    this.$set(this, "disabledBtnConfirm", disabledState.disabledBtnConfirm);
  }

  /**
   * 用途: 整備なし選択時の確定 state を作る。
   * WHY: public/ref 互換の入口から helper/service 境界へ処理を渡すため。
   */
  onNoSeibi() {
    const noSeibiState = WorkBuhinReset.buildNoSeibiState();
    const noSeibiEffectState = WorkBuhinReset.buildNoSeibiApplyEffectState(noSeibiState);
    this.$set(this, "listSelectedBuhin", noSeibiEffectState.listSelectedBuhin);
    this.$set(this, "listManualBuhin", noSeibiEffectState.listManualBuhin);
    if (noSeibiEffectState.shouldFilterManualBuhin) {
      this.filterManualBuhin();
    }
    if (noSeibiEffectState.shouldMapBuhin) {
      this.mapBuhin();
    }
    this.$set(this, "disabledBtnConfirm", noSeibiEffectState.disabledBtnConfirm);
    this.$set(this, "disabledBtnNoBuhin", noSeibiEffectState.disabledBtnNoBuhin);
    this.$set(this, "osusumeBuhinList", noSeibiEffectState.osusumeBuhinList);
    this.$set(this, "activeCateBuhins", noSeibiEffectState.activeCateBuhins);
    this.$set(this, "buhinContent", noSeibiEffectState.buhinContent);
    this.$set(this, "activeBuhinShubetsuId", noSeibiEffectState.activeBuhinShubetsuId);
    this.$set(this, "activeBuhinCateIndex", noSeibiEffectState.activeBuhinCateIndex);
  }

  /**
   * 用途: isDispDiscount で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  isDispDiscount(buhin: any) {
    return WorkBuhinDisplay.buildBuhinPriceDisplayState(
      buhin,
      this.isDiscount
    ).shouldDisplayDiscountPrice;
  }

  /**
   * 用途: 手入力作業の削除押下時
   * WHY: 既存の関数説明を block comment 形式に揃えるため。
   */
  removeWork(e: any, index: number) {
    const deleteDialogOpenState = WorkBuhinDelete.buildManualWorkDeleteDialogOpenActionState(index);
    const deleteDialogOpenEffectState = WorkBuhinDelete.buildManualWorkDeleteDialogOpenApplyEffectState(
      deleteDialogOpenState
    );
    if (deleteDialogOpenEffectState.shouldStopPropagation) {
      e.stopPropagation();
    }
    this.tmpResetWorkIndex = deleteDialogOpenEffectState.tmpResetWorkIndex;
    this.tmpDeleteWorkIndex = deleteDialogOpenEffectState.tmpDeleteWorkIndex;
    if (deleteDialogOpenEffectState.shouldOpenDeleteDialog) {
      this.$refs.askDeleteDialog.onOpen();
    }
  }

  /**
   * 用途: applyWorkResetState の effect state を Vue state や副作用へ反映する。
   * WHY: helper の純粋判定と component の実反映を分けるため。
   */
  applyWorkResetState(resetState: WorkBuhinReset.WorkBuhinResetState) {
    const resetEffectState = WorkBuhinReset.buildWorkResetApplyEffectState(resetState);
    const resetCommitEffectState =
      WorkBuhinReset.buildWorkResetCommitApplyEffectState(resetEffectState);
    this.applyWorkResetCommitEffectState(resetCommitEffectState);
  }

  /*
   * applyWorkResetCommitEffectState を applyWorkResetState() から分離し、
   * 通常作業/おすすめ整備 reset 時の state 反映と保存呼び出し順を一箇所に寄せるため。
   */
  applyWorkResetCommitEffectState(effectState: WorkBuhinReset.WorkResetCommitApplyEffectState) {
    this.isResetSeibi = effectState.isResetSeibi;
    this.listSelectedBuhin = effectState.listSelectedBuhin;
    this.listManualBuhin = effectState.listManualBuhin;
    this.listManualBuhinFiltered = effectState.listManualBuhinFiltered;
    if (effectState.shouldSetBuhinToWork) {
      this.setBuhinToWork(effectState.status);
    }
    this.disabledBtnConfirm = effectState.disabledBtnConfirm;
  }

  /**
   * 用途: 通常作業/おすすめ整備の削除押下時
   * WHY: 既存の関数説明を block comment 形式に揃えるため。
   */
  showConfirmResetWork(e: any, workIndex: number) {
    const deleteDialogOpenState = WorkBuhinDelete.buildResetWorkDeleteDialogOpenActionState(workIndex);
    const deleteDialogOpenEffectState = WorkBuhinDelete.buildResetWorkDeleteDialogOpenApplyEffectState(
      deleteDialogOpenState
    );
    if (deleteDialogOpenEffectState.shouldStopPropagation) {
      e.stopPropagation();
    }
    this.activeWorkIndex = deleteDialogOpenEffectState.activeWorkIndex;
    this.isManualWork = deleteDialogOpenEffectState.isManualWork;
    this.tmpResetWorkIndex = deleteDialogOpenEffectState.tmpResetWorkIndex;
    if (deleteDialogOpenEffectState.shouldOpenDeleteDialog) {
      this.$refs.askDeleteDialog.onOpen();
    }
  }

  /**
   * 用途: 手入力作業の追加を開始する。
   * WHY: 入力値検証、工賃取得、追加確定の順序を component 側で保つため。
   */
  addWork() {
    const addStartActionState = WorkBuhinManualWork.buildManualWorkAddStartActionState({
      manualWorkNm: this.manualWorkNm,
      manualKousuu: this.manualKousuu
    });
    const addStartEffectState = WorkBuhinManualWork.buildManualWorkAddStartApplyEffectState(addStartActionState);
    if (addStartEffectState.shouldLoadManualKouchin) {
      const work = addStartEffectState.work as Work;
      let inspectDescription = this.setInspectDescription(work);
      this.reqService.getManualKouchin(inspectDescription).then((res: any) => {
        this.completeAddManualWork(WorkBuhinManualWork.applyManualWorkKouchin(work, res.body));
      }, (err: any) => {
        this.completeAddManualWork(work);
      });
    }
  }

  /**
   * 用途: 手入力作業追加の完了 state を反映する。
   * WHY: API 成功/失敗後の共通反映処理を一箇所に寄せるため。
   */
  completeAddManualWork(work: Work) {
    const addCompleteActionState = WorkBuhinManualWork.buildManualWorkAddCompleteActionState({
      manualSeibiList: this.workAndBuhinDataService.getManualSeibiList(),
      work
    });
    const addCompleteEffectState = WorkBuhinManualWork.buildManualWorkAddCompleteApplyEffectState(
      addCompleteActionState
    );
    const addCompleteCommitEffectState =
      WorkBuhinManualWork.buildManualWorkAddCompleteCommitApplyEffectState(addCompleteEffectState);
    this.applyManualWorkAddCompleteCommitEffectState(addCompleteCommitEffectState);
  }

  /*
   * applyManualWorkAddCompleteCommitEffectState を completeAddManualWork() から分離し、
   * 手入力作業追加完了後の state 反映、scroll、作業選択、遅延確定予約を一箇所に寄せるため。
   */
  applyManualWorkAddCompleteCommitEffectState(
    effectState: WorkBuhinManualWork.ManualWorkAddCompleteCommitApplyEffectState
  ) {
    this.workAndBuhinDataService.setManualSeibiList(effectState.manualSeibiList);
    this.manualWorkNm = effectState.manualWorkNm;
    this.manualKousuu = effectState.manualKousuu;
    this.scrollTobottom(effectState.scrollTargetId);
    if (effectState.shouldSetLoading) {
      this.$set(this, "loading", effectState.loading);
    }
    if (effectState.shouldSelectWork) {
      this.onSelectWork(
        effectState.selectWork,
        effectState.selectWorkIndex,
        effectState.selectWorkIsManual,
        effectState.selectWorkForceSelect
      );
    }
    if (effectState.shouldConfirmNoBuhinAfterDelay) {
      setTimeout(() => {
        const delayedConfirmActionState = WorkBuhinManualWork.buildManualWorkAddDelayedConfirmActionState({
          shouldConfirmNoBuhinAfterDelay: effectState.shouldConfirmNoBuhinAfterDelay,
          loadingAfterDelay: effectState.loadingAfterDelay
        });
        const delayedConfirmEffectState = WorkBuhinManualWork.buildManualWorkAddDelayedConfirmApplyEffectState(
          delayedConfirmActionState
        );
        this.applyManualWorkAddDelayedConfirmEffectState(delayedConfirmEffectState);
      }, effectState.confirmDelay);
    }
  }

  /*
   * applyManualWorkAddDelayedConfirmEffectState を completeAddManualWork() の遅延処理から分離し、
   * 手入力作業追加後に loading を戻して部品なし確定へ進む条件を一箇所に寄せるため。
   */
  applyManualWorkAddDelayedConfirmEffectState(
    effectState: WorkBuhinManualWork.ManualWorkAddDelayedConfirmApplyEffectState
  ) {
    if (effectState.shouldSetLoading) {
      this.$set(this, "loading", effectState.loading);
    }
    if (effectState.shouldConfirmNoBuhin) {
      this.onConfirmNoBuhin();
    }
  }

  /**
   * 用途: 手入力部品の追加 state を作る。
   * WHY: 入力値と選択中作業への反映順を component 側で固定するため。
   */
  addBuhin() {
    const addApplyState = WorkBuhinManual.buildManualBuhinAddApplyState({
      manualBuhinNm: this.manualBuhinNm,
      buhinShubetsuId: this.activeBuhinShubetsuId,
      activeWorkIndex: this.activeWorkIndex,
      doneStatus: STATUS_SELECT_WORK_BUHIN.Done
    });
    const addApplyEffectState = WorkBuhinManual.buildManualBuhinAddApplyEffectState(addApplyState);
    const addCommitEffectState =
      WorkBuhinManual.buildManualBuhinAddCommitApplyEffectState(addApplyEffectState);
    this.applyManualBuhinAddCommitEffectState(addCommitEffectState);
  }

  /*
   * applyManualBuhinAddCommitEffectState を addBuhin() から分離し、
   * 手入力部品追加後の list 追加、入力欄 clear、作業選択状態の反映順を一箇所に寄せるため。
   */
  applyManualBuhinAddCommitEffectState(
    effectState: WorkBuhinManual.ManualBuhinAddCommitApplyEffectState
  ) {
    this.listManualBuhin.push(effectState.buhin);
    this.listManualBuhinFiltered.push(effectState.buhin);
    this.disabledBtnConfirm = effectState.disabledBtnConfirm;
    this.manualBuhinNm = effectState.manualBuhinNm;
    this.scrollTobottom(effectState.scrollTargetId);
    if (effectState.shouldUpdateWorkBuhinSelected) {
      const work = this.getWork();
      work.buhinSelected = effectState.workBuhinSelected;
      this.isChange = effectState.isChange;
    }
    this.listSelectedBuhin.push(effectState.buhin);
  }

  /**
   * 用途: 手入力部品追加ボタンの押下を処理する。
   * WHY: dialog 表示と追加反映の入口を分けるため。
   */
  onClickAddManualBuhin() {
    const addClickActionState = WorkBuhinManual.buildManualBuhinAddClickActionState({
      disabledBtnNoBuhin: this.isNoBuhinConfirmDisabled(),
      manualBuhinNm: this.manualBuhinNm,
      manualBuhinList: this.listManualBuhin
    });
    const addClickEffectState = WorkBuhinManual.buildManualBuhinAddClickApplyEffectState(addClickActionState);
    const addClickCommitEffectState =
      WorkBuhinManual.buildManualBuhinAddClickCommitApplyEffectState(addClickEffectState);
    this.applyManualBuhinAddClickCommitEffectState(addClickCommitEffectState);
  }

  /*
   * applyManualBuhinAddClickCommitEffectState を onClickAddManualBuhin() から分離し、
   * 手入力部品追加ボタン押下後の重複 dialog 表示と追加実行を一箇所に寄せるため。
   */
  applyManualBuhinAddClickCommitEffectState(
    effectState: WorkBuhinManual.ManualBuhinAddClickCommitApplyEffectState
  ) {
    if (effectState.shouldOpenAddDialog) {
      this.$refs.askAddDialog.onOpen();
    }
    if (effectState.shouldAddBuhin) {
      this.addBuhin();
    }
  }

  /**
   * 用途: 手入力部品および純正部品の削除押下時
   * WHY: 既存の関数説明を block comment 形式に揃えるため。
   */
  removeBuhin(e: any, buhin: BuhinDetail) {
    const deleteDialogOpenState = WorkBuhinDelete.buildManualBuhinDeleteDialogOpenActionState({
      disabledBtnNoBuhin: this.disabledBtnNoBuhin,
      deletedBuhin: buhin
    });
    const deleteDialogOpenEffectState = WorkBuhinDelete.buildManualBuhinDeleteDialogOpenApplyEffectState(
      deleteDialogOpenState
    );
    const deleteDialogOpenCommitEffectState =
      WorkBuhinDelete.buildManualBuhinDeleteDialogOpenCommitApplyEffectState(
        deleteDialogOpenEffectState
      );
    this.applyManualBuhinDeleteDialogOpenCommitEffectState(
      e,
      deleteDialogOpenCommitEffectState
    );
  }

  /*
   * applyManualBuhinDeleteDialogOpenCommitEffectState を removeBuhin() から分離し、
   * 手入力部品/純正部品削除 dialog 前のイベント停止、一時 state、dialog 表示を一箇所に寄せるため。
   */
  applyManualBuhinDeleteDialogOpenCommitEffectState(
    e: any,
    effectState: WorkBuhinDelete.ManualBuhinDeleteDialogOpenCommitApplyEffectState
  ) {
    if (effectState.shouldStopPropagation) {
      e.stopPropagation();
    }
    if (effectState.shouldOpenDeleteDialog) {
      this.tmpResetWorkIndex = effectState.tmpResetWorkIndex;
      this.tmpDeleteWorkIndex = effectState.tmpDeleteWorkIndex;
      this.tmpDeletedBuhin = effectState.tmpDeletedBuhin;
      this.$refs.askDeleteDialog.onOpen();
    }
  }
  /**
   * 用途: 指定要素へスクロールする。
   * WHY: DOM 操作の副作用を component 境界に残すため。
   */
  scrollTobottom(id: string) {
    const targetState = WorkBuhinDisplay.buildBuhinBottomScrollTargetState(id);
    setTimeout(() => {
      const lookupState = WorkBuhinDisplay.buildBuhinBottomScrollElementLookupState(targetState);
      let list = lookupState.shouldGetElementById
        ? document.getElementById(lookupState.elementId)
        : null;
      const scrollActionState = WorkBuhinDisplay.buildBuhinBottomScrollActionState({
        hasElement: !!list,
        scrollHeight: list ? list.scrollHeight : 0
      });
      const scrollApplyEffectState = WorkBuhinDisplay.buildBuhinBottomScrollActionApplyEffectState(
        scrollActionState
      );
      if (list && scrollApplyEffectState.shouldScrollToBottom) {
        list.scrollTo(0, scrollApplyEffectState.scrollTop);
        list = null;
      }
    }, targetState.delay);
  }

  /**
   * 用途: onSelectBuhinTab で UI event や親 event を受けて処理を開始する。
   * WHY: 画面操作の入口と helper/service 呼び出しを明確に分けるため。
   */
  onSelectBuhinTab(index: number) {
    const tabState = WorkBuhinTab.buildBuhinTabApplyActionState({
      index,
      activeBuhinCateIndex: this.activeBuhinCateIndex,
      buhinCategory: this.buhinCategory,
      freeOfChargeBuhinList: this.freeOfChargeBuhinList
    });
    const tabEffectState = WorkBuhinTab.buildBuhinTabApplyEffectState(tabState);
    if (tabEffectState.shouldApply) {
      this.activeBuhinCateIndex = tabEffectState.activeBuhinCateIndex;
      this.activeBuhinShubetsuId = tabEffectState.activeBuhinShubetsuId;
      this.$set(this, "activeCateBuhins", tabEffectState.activeCateBuhins);
      this.$set(this, "buhinContent", this.filterButteryBuhin(tabEffectState.buhinContent));
    }
    if (tabEffectState.shouldFilterManualBuhin) {
      this.filterManualBuhin();
    }
    if (tabEffectState.shouldMapBuhin) {
      this.mapBuhin();
    }
  }

  /**
   * 用途: onFilter で UI event や親 event を受けて処理を開始する。
   * WHY: 画面操作の入口と helper/service 呼び出しを明確に分けるため。
   */
  onFilter(cd: string) {
    const filterState = WorkBuhinDisplay.buildBuhinFilterActionState({
      selFilter: this.selFilter,
      buhinBunruiCd: cd,
      sourceBuhinContent: this.buhinCategory[this.activeBuhinCateIndex].items,
      activeCateBuhins: this.activeCateBuhins,
      selectedBuhinList: this.listSelectedBuhin,
      freeOfChargeBuhinList: this.freeOfChargeBuhinList
    });
    const filterEffectState = WorkBuhinDisplay.buildWorkBuhinFilterApplyEffectState(filterState);
    this.selFilter = filterEffectState.selFilter;
    if (filterEffectState.shouldApplyBuhinContent) {
      this.$set(this, "buhinContent", this.filterButteryBuhin(filterEffectState.buhinContent));
    }
  }

  /**
   * 用途: 現在の部品分類フィルタ条件を再適用する。
   * WHY: バッテリー型番検索や規格ボタンの変更後に、既存の分類表示条件を保ったまま候補だけを絞り込むため。
   */
  setFilter() {
    const buhinContent = WorkBuhinDisplay.buildFilteredBuhinContent({
      selFilter: this.selFilter,
      sourceBuhinContent: this.buhinCategory[this.activeBuhinCateIndex].items,
      activeCateBuhins: this.activeCateBuhins,
      selectedBuhinList: this.listSelectedBuhin,
      freeOfChargeBuhinList: this.freeOfChargeBuhinList
    });
    this.$set(this, "buhinContent", this.filterButteryBuhin(buhinContent));
  }

  /**
   * 用途: findJunseiBuhinIndex で対象 item の位置や種別を解決する。
   * WHY: 一覧操作時の探索条件を helper 呼び出しに寄せるため。
   */
  findJunseiBuhinIndex(item: any) {
    return WorkBuhinMatch.buildBuhinIndexState(this.listSelectedBuhin, item).junseiBuhinIndex;
  }

  /**
   * 部品の＋ボタン押下時の処理
   * @param item 部品
   * @param i buhinContentのインデックス -1:手入力部品または純正部品
   * @param j buhinContent[i]のインデックス
   */
  onPlus(item: any, i: number, j: number) {
    if (this.isBuhinQuantityPlusDisabled(item)) {
      return;
    }
    WorkBuhinQuantity.increaseBuhinQuantity(item);
    this.hasPendingBuhinEdit = true;
    const plusEffectState = WorkBuhinQuantity.buildBuhinQuantityPlusApplyEffectState({
      isNormalBuhin: i > -1
    });
    if (plusEffectState.shouldUpdateNormalBuhinContent) {
      // 手入力でも純正でもない部品は、 listSelectedBuhin を更新する。
      this.buhinContent[i].items[j].quantity = item.quantity;
    }
    if (plusEffectState.shouldSyncNormalBuhinSelection) {
      const isSelected = WorkBuhinQuantity.syncNormalBuhinSelection(this.listSelectedBuhin, item);
      this.setRecommendBuhinSelected(item, isSelected);
    }
    if (plusEffectState.shouldSyncManualOrJunseiBuhinSelection) {
      // 手入力部品または純正部品は、 listSelectedBuhin と listManualBuhin を更新する。
      WorkBuhinQuantity.syncManualOrJunseiBuhinSelection(this.listSelectedBuhin, item);
    }
    if (plusEffectState.shouldSyncManualBuhinListQuantity) {
      WorkBuhinQuantity.syncManualBuhinListQuantityOnPlus(this.listManualBuhin, item);
    }
    if (plusEffectState.shouldCheckDisabledBtnConfirm) {
      this.checkDisabledBtnConfirm();
    }
  }

  /**
   * 用途: onMinus で UI event や親 event を受けて処理を開始する。
   * WHY: 画面操作の入口と helper/service 呼び出しを明確に分けるため。
   */
  onMinus(item: any, i: number, j: number) {
    if (this.isBuhinQuantityMinusDisabled(item)) {
      return;
    }
    WorkBuhinQuantity.decreaseBuhinQuantity(item);
    this.hasPendingBuhinEdit = true;
    const minusEffectState = WorkBuhinQuantity.buildBuhinQuantityMinusApplyEffectState({
      isNormalBuhin: i > -1
    });
    if (minusEffectState.shouldUpdateNormalBuhinContent) {
      this.buhinContent[i].items[j].quantity = item.quantity;
    }
    if (minusEffectState.shouldSyncNormalBuhinSelection) {
      const syncResult = WorkBuhinQuantity.syncNormalBuhinSelectionAfterDecrease(this.listSelectedBuhin, item);
      if (syncResult.found && minusEffectState.shouldUpdateRecommendBuhinSelectedWhenFound) {
        this.setRecommendBuhinSelected(item, syncResult.isSelected);
      }
    }
    if (minusEffectState.shouldSyncManualOrJunseiBuhinSelection) {
      // 手入力部品または純正部品
      WorkBuhinQuantity.syncManualOrJunseiBuhinSelection(this.listSelectedBuhin, item);
    }
    if (minusEffectState.shouldCheckDisabledBtnConfirm) {
      this.checkDisabledBtnConfirm();
    }
  }

  /**
   * 用途: 親 ref から部品選択状態を再初期化する。
   * WHY: 親側互換 API と遅延復元の順序を維持するため。
   */
  reInitBuhin(data: any) {
    this.buhinRestoreCount++;
    this.resetBuhin();
    const work = this.getWork(data);
    const reInitState = WorkBuhinInit.resolveReInitBuhinState(work);
    if (reInitState.shouldSetActiveSeibiId) {
      this.activeSeibiId = reInitState.activeSeibiId;
    }
    const delayedAction = WorkBuhinInit.buildReInitBuhinDelayedAction({
      data,
      work,
      reInitState,
      activeWorkIndex: this.activeWorkIndex,
      isManualWork: this.isManualWork
    });
    setTimeout(() => {
      try {
        const confirmEffectState = WorkBuhinInit.buildReInitBuhinDelayedConfirmEffectState(
          delayedAction
        );
        if (confirmEffectState.shouldKeepBuhinMd15) {
          this.onkeepBuhinMD15(confirmEffectState.keepBuhinMd15Data);
        } else if (confirmEffectState.shouldKeepBuhinConfirmOsusume) {
          this.keepBuhinConfirmOsusume(confirmEffectState.keepBuhinConfirmOsusumeWork);
        }
        const selectionEffectState = WorkBuhinInit.buildReInitBuhinDelayedSelectionEffectState(
          delayedAction
        );
        if (selectionEffectState.shouldSelectWork) {
          this.onSelectWork(
            selectionEffectState.selectWork,
            selectionEffectState.selectWorkIndex,
            selectionEffectState.selectWorkIsManual,
            selectionEffectState.forceSelectWork
          );
        }
        if (selectionEffectState.shouldForceUpdate) {
          this.$forceUpdate();
        }
      } finally {
        this.buhinRestoreCount--;
      }
    }, WorkBuhinInit.RE_INIT_BUHIN_DELAY_MS);
  }

  /**
   * 用途: initListSelectedBuhin で初期選択や初期表示 state を整える。
   * WHY: created 後の復元/初期化手順を明示するため。
   */
  initListSelectedBuhin(work: any) {
    this.hasPendingBuhinEdit = false;
    const isRecommend = WorkBuhinWorkSelection.isRecommendInspectType(work.sknInspectType);
    if (!this.isDialog) {
      if (isRecommend) {
        this.keepBuhinConfirmOsusume(work);
      } else {
        this.keepBuhinConfirm([work]);
      }
    } else {
      this.onkeepBuhinMD15();
    }
    const selectionState = WorkBuhinSelection.buildWorkBuhinSelectionState(work, {
      isRecommend
    });
    work.buhinList = selectionState.workBuhinList;
    work.osusumeBuhinList = selectionState.osusumeBuhinList;

    this.$set(this, "freeOfChargeBuhinList", selectionState.freeOfChargeBuhinList);
    this.$set(this, "listSelectedBuhin", selectionState.selectedBuhinList);
    this.$set(this, "listManualBuhin", this.utils.deepCopy(selectionState.manualBuhinList));
    this.$set(this, "listBuhinActiveSeibi", selectionState.activeSeibiBuhinList);
    this.filterManualBuhin();
    this.checkDisabledBtnConfirm(work);
  }

  onSelectWork(
    work: Work,
    index: number,
    isManual: boolean,
    forceSelect: boolean = false
  ) {
    const selectActionState = WorkBuhinWorkSelection.buildWorkSelectActionState({
      work,
      index,
      isManual,
      forceSelect,
      activeWorkIndex: this.activeWorkIndex,
      isManualWork: this.isManualWork,
      isDialog: this.isDialog,
      listBuhinDataLength: this.listBuhinData.length
    });
    const selectApplyEffectState = WorkBuhinWorkSelection.buildWorkSelectApplyEffectState(selectActionState);
    if (!selectApplyEffectState.shouldContinue) {
      return;
    }
    // 選択中の作業とは別の作業を選択し、かつその作業が手入力部品を含む場合
    if (selectApplyEffectState.shouldClearManualBuhinFilter) {
      this.$set(this, "listManualBuhinFiltered", []);
    }

    if (selectApplyEffectState.shouldResetSelectionState) {
      this.firstBuhinCd = selectApplyEffectState.firstBuhinCd;
      this.nRetryScroll = selectApplyEffectState.nRetryScroll;
      this.isDiscount = selectApplyEffectState.initialIsDiscount; // reset for init.
    }

    if (!selectApplyEffectState.hasBuhinData) {
      return;
    }

    if (selectApplyEffectState.shouldSelectWork) {
      this.$set(this, "osusumeBuhinList", []);
      if (selectApplyEffectState.shouldSnapshotWorkBeforeChange) {
        this.workBeforeChange = this.utils.deepCopy(work);
        this.buhinChangeList = {};
      }
      this.isManualWork = selectApplyEffectState.isManualWork;
      this.activeWorkIndex = selectApplyEffectState.activeWorkIndex;
      this.activeSeibiId = selectApplyEffectState.activeSeibiId;
      if (selectApplyEffectState.shouldSetActiveSeibiNm) {
        this.activeSeibiNm = selectApplyEffectState.activeSeibiNm;
      }
      this.initListSelectedBuhin(work);
      const extremeMasterState = WorkBuhinTab.buildExtremeBuhinMasterState(this.listBuhinActiveSeibi);
      const tabDecision = WorkBuhinWorkSelection.resolveWorkBuhinTabDecision({
        work,
        buhinCategory: this.buhinCategory,
        isDialog: this.isDialog,
        hasExtremeMaster: extremeMasterState.hasExtremeMaster,
        isUseJunseiBuhin: this.isUseJunseiBuhin
      });
      const tabActionState = WorkBuhinWorkSelection.buildWorkSelectTabActionState({
        work,
        tabDecision,
        forceSelect
      });
      const tabApplyEffectState = WorkBuhinWorkSelection.buildWorkSelectTabApplyEffectState(tabActionState);
      if (tabApplyEffectState.shouldSetOsusumeBuhinList) {
        this.osusumeBuhinList = tabApplyEffectState.osusumeBuhinList;
      }
      if (tabApplyEffectState.shouldSelectOsusumeTab) {
        this.onSelectOsusumeTab();
      } else if (tabApplyEffectState.shouldSelectJunseiTab) {
        this.onSelectJunseiTab();
      } else if (tabApplyEffectState.shouldRequestJunseiBuhin) {
        this.getJunseiBuhinByNisseirenWork(tabApplyEffectState.sknNisseirenCd);
      } else if (tabApplyEffectState.shouldSelectExtremeTab) {
        this.onSelectExtremeTab();
      } else if (tabApplyEffectState.shouldSelectBuhinShubetsu) {
        this.selectBuhinShubetsu(
          tabApplyEffectState.buhinShubetsuCd,
          tabApplyEffectState.buhinBunruiList
        );
      }
      if (tabApplyEffectState.shouldReturnAfterAction) {
        return;
      }
      if (tabApplyEffectState.shouldScrollToBuhin) {
        this.scrollToBuhin();
      }
    }

    this.isDiscount = selectApplyEffectState.isDiscount;
  }

  /**
   * 用途: findBuhinShubetsuCd で対象 item の位置や種別を解決する。
   * WHY: 一覧操作時の探索条件を helper 呼び出しに寄せるため。
   */
  findBuhinShubetsuCd(buhinShubetsuId: any) {
    return WorkBuhinWorkSelection.findBuhinShubetsuCdById(this.buhinCategory, buhinShubetsuId);
  }

  /**
   * 用途: 部品種別選択時にタブ/一覧 state を更新する。
   * WHY: 種別選択の fallback と表示反映を同じ入口に寄せるため。
   */
  selectBuhinShubetsu(buhinShubetsuCd: string, buhinBunruiList: any) {
    const actionState = this.workAndBuhinDataService.buildSelectBuhinShubetsuApplyActionState({
      activeWorkIndex: this.activeWorkIndex,
      hasBuhinData: this.listBuhinData.length > 0,
      buhinShubetsuCd,
      buhinBunruiList,
      buhinCategory: this.buhinCategory,
      activeBuhinCateIndex: this.activeBuhinCateIndex,
      isManualWork: this.isManualWork,
      freeOfChargeBuhinList: this.freeOfChargeBuhinList
    });
    if (!actionState.shouldApply) {
      return;
    }
    const effectState = WorkBuhinTab.buildSelectBuhinShubetsuApplyEffectState(actionState);
    if (effectState.shouldSetDefaultState) {
      this.defualtBuhinShubetsuCd = effectState.defaultState.defualtBuhinShubetsuCd;
      this.defualtBuhinBunruiCdList = effectState.defaultState.defualtBuhinBunruiCdList;
    }
    if (effectState.shouldSelectBuhinTab) {
      this.defualtBuhinShubetsuIndex = effectState.selectBuhinTabIndex;
      this.onSelectBuhinTab(effectState.selectBuhinTabIndex);
    } else if (effectState.shouldApplyActiveCateBuhins) {
      this.$set(this, "activeCateBuhins", effectState.activeCateBuhins);
      if (effectState.shouldMapBuhin) {
        this.mapBuhin();
      }
    } else if (effectState.shouldSetOsusumeBuhinList) {
      this.osusumeBuhinList = effectState.osusumeBuhinList;
      this.onSelectOsusumeTab();
    } else if (effectState.shouldSelectExtremeTab) {
      this.onSelectExtremeTab();
    } else if (effectState.shouldSelectManualDefaultTab) {
      this.onSelectBuhinTab(effectState.manualDefaultTabIndex);
    } else if (effectState.shouldApplyEmptyState) {
      this.activeBuhinCateIndex = effectState.emptyActiveBuhinCateIndex;
      this.defualtBuhinShubetsuIndex = effectState.emptyDefualtBuhinShubetsuIndex;
      this.selFilter = effectState.emptySelFilter;
      this.buhinContent = effectState.emptyBuhinContent;
      this.activeCateBuhins = effectState.emptyActiveCateBuhins;
    }
  }

  /**
   * 用途: 確定完了メッセージを表示する。
   * WHY: 親 ref 互換の通知 UI 副作用を component 側に残すため。
   */
  showMsgConfirm() {
    const messageState = WorkBuhinPublicApi.buildWorkBuhinConfirmMessageState(this.isBuhin);
    this.$message({
      message: messageState.message,
      type: "info",
      duration: 700,
      customClass: "msg-center shadow",
      showClose: true
    });
    setTimeout(() => {
      const btnClose = document.getElementById(messageState.focusElementId);
      const focusState = WorkBuhinPublicApi.buildWorkBuhinConfirmFocusTargetState(btnClose);
      if (focusState.shouldFocus) {
        focusState.target.focus();
      }
    }, 0);
  }

  /**
   * 用途: checkIsDone で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  checkIsDone() {
    const work: any = this.getWork();
    return work.buhinSelected === STATUS_SELECT_WORK_BUHIN.Done;
  }

  /**
   * 用途: checkBuhinChange で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  checkBuhinChange(work: any) {
    return JSON.stringify(this.workConfirm) == JSON.stringify(work);
  }

  /**
   * 用途: 部品あり確定を開始する。
   * WHY: 確認ボタンから保存/emit までの入口を明示するため。
   */
  onConfirm() {
    if (this.isBuhinConfirmBusy()) {
      return;
    }
    const confirmActionState = WorkBuhinReset.buildBuhinConfirmActionState();
    this.isBuhin = confirmActionState.isBuhin;
    this.isResetSeibi = confirmActionState.isResetSeibi;
    const doEmit = this.setBuhinToWork(confirmActionState.status);
    const afterSaveActionState = WorkBuhinReset.buildBuhinConfirmAfterSaveActionState({
      doEmit,
      isDialog: this.isDialog
    });
    const afterSaveEffectState = WorkBuhinReset.buildBuhinConfirmAfterSaveApplyEffectState(
      afterSaveActionState
    );
    if (afterSaveEffectState.shouldShowMsgConfirm) {
      // ダイアログ：配列に保存、即終了 -> 完了メッセージを出す
      // ダイアログではない：保存Api実行、時間がかかる
      this.showMsgConfirm();
    }
    if (afterSaveEffectState.shouldResetKouchinChange) {
      this.isKouchinChange = afterSaveEffectState.isKouchinChange;
    }
  }

  /**
   * 用途: 部品なし確定を開始する。
   * WHY: 部品なし時の status 更新と保存順を既存通り維持するため。
   */
  onConfirmNoBuhin() {
    if (this.isBuhinConfirmBusy()) {
      return;
    }
    const noBuhinState = WorkBuhinReset.buildNoBuhinConfirmState({
      buhinContent: this.buhinContent,
      listManualBuhin: this.listManualBuhin,
      isDialog: this.isDialog
    });
    this.applyNoBuhinConfirmState(noBuhinState);

    const afterActionState = WorkBuhinReset.buildNoBuhinConfirmAfterActionState(noBuhinState);
    const afterEffectState = WorkBuhinReset.buildNoBuhinConfirmAfterApplyEffectState(
      afterActionState
    );
    // 画面上でも手入力部品を削除した表示にするため、別配列も0にする
    if (afterEffectState.shouldFilterManualBuhin) {
      this.filterManualBuhin();
    }

    const doEmit = this.setBuhinToWork(afterEffectState.status);
    if (doEmit && afterEffectState.shouldShowMsgConfirm) {
      // ダイアログ：配列に保存、即終了 -> 完了メッセージを出す
      // ダイアログではない：保存Api実行、時間がかかる
      this.showMsgConfirm();
    }
    if (afterEffectState.shouldClearDeletedManualBuhinList) {
      // 削除確定リストの初期化
      this.tmpDeletedManualBuhinList = afterEffectState.tmpDeletedManualBuhinList;
    }
  }

  /**
   * 用途: applyNoBuhinConfirmState の effect state を Vue state や副作用へ反映する。
   * WHY: helper の純粋判定と component の実反映を分けるため。
   */
  applyNoBuhinConfirmState(noBuhinState: WorkBuhinReset.WorkBuhinNoBuhinConfirmState) {
    this.isBuhin = noBuhinState.isBuhin;
    this.isResetSeibi = noBuhinState.isResetSeibi;
    this.$set(this, "buhinContent", noBuhinState.buhinContent);
    this.$set(this, "listSelectedBuhin", noBuhinState.listSelectedBuhin);
    this.$set(this, "listManualBuhin", noBuhinState.listManualBuhin);
    this.disabledBtnConfirm = noBuhinState.disabledBtnConfirm;
    this.isKouchinChange = noBuhinState.isKouchinChange;
    this.hasPendingBuhinEdit = false;
  }

  /**
   * 用途: 選択部品を作業へ反映して保存/通知する。
   * WHY: status 更新、socket、emit の副作用順を固定するため。
   */
  setBuhinToWork(status: number) {
    this.isChange = true;
    const work = this.getTargetWorkForBuhinSave();
    this.notifyWorkBuhinSocket(work, status);

    const saveState = WorkBuhinSave.buildWorkBuhinSaveState(
      work,
      this.listSelectedBuhin,
      this.listManualBuhin,
      {
        activeBuhinShubetsuId: this.activeBuhinShubetsuId,
        isRecommendManualWithOsusume: WorkBuhinSave.shouldSaveRecommendManualOsusume(work)
      }
    );
    const saveEffectState = WorkBuhinSave.buildWorkBuhinSaveApplyEffectState(saveState);
    work.buhinList = saveEffectState.buhinList;
    if (saveEffectState.shouldApplyOsusumeBuhinList) {
      work.osusumeBuhinList = saveEffectState.osusumeBuhinList;
    }
    work.manualBuhinList = saveEffectState.manualBuhinList;
    this.applyWorkBuhinStatus(work, status);
    this.restoreBuhinConfirmForDialog();

    const afterSaveActionState = WorkBuhinSave.buildSetBuhinToWorkAfterSaveActionState({
      buhinChangeList: this.buhinChangeList,
      isBuhin: this.isBuhin,
      isDone: this.checkIsDone(),
      isWorkUnchanged: this.checkBuhinChange(work),
      hasExplicitBuhinEdit: this.hasExplicitBuhinEdit,
      suppressUnchangedNoBuhinConfirm: !this.editSeibi
    });
    this.hasExplicitBuhinEdit = false;
    this.hasPendingBuhinEdit = false;
    const afterSaveEffectState = WorkBuhinSave.buildSetBuhinToWorkAfterSaveApplyEffectState(
      afterSaveActionState
    );
    if (afterSaveEffectState.shouldApplyResetSeibiConfirm) {
      this.applyResetSeibiConfirmState(work);
    }
    if (afterSaveEffectState.shouldCommitBuhinConfirm) {
      this.commitBuhinConfirmState(work);
    }
    if (afterSaveEffectState.shouldEmitBuhinConfirm) {
      this.emitBuhinConfirm(status, afterSaveEffectState.changeList);
    }

    return afterSaveEffectState.doEmit;
  }

  /**
   * 用途: 保存対象の作業を取得する。
   * WHY: active index と手入力作業の差異を data service 側に寄せるため。
   */
  getTargetWorkForBuhinSave() {
    return this.workAndBuhinDataService.getTargetWorkForBuhinSave(
      this.activeWorkIndex,
      this.isManualWork
    );
  }

  /**
   * 用途: 作業部品選択の socket 通知を行う。
   * WHY: 外部通知の副作用を component 境界に残すため。
   */
  notifyWorkBuhinSocket(work: any, status: number) {
    const socketAction = this.workAndBuhinDataService.resolveWorkBuhinSocketAction(work, status);
    const socketEffectState = WorkBuhinSave.buildWorkBuhinSocketApplyEffectState(socketAction);
    if (!socketEffectState.shouldApplySocket) {
      return;
    }
    if (socketEffectState.shouldSetSocket) {
      this.isSocket = socketEffectState.isSocket;
    }
    if (socketEffectState.shouldRemoveSeibiId) {
      this.removeSeibiId(socketEffectState.removePayload);
    } else if (socketEffectState.shouldAddSeibiId) {
      this.addSeibiId(socketEffectState.addPayload);
    }
  }

  /**
   * 用途: applyWorkBuhinStatus の effect state を Vue state や副作用へ反映する。
   * WHY: helper の純粋判定と component の実反映を分けるため。
   */
  applyWorkBuhinStatus(work: any, status: number) {
    const statusState = WorkBuhinSave.resolveWorkBuhinStatusState({
      status,
      editSeibi: this.editSeibi
    });
    const statusEffectState = WorkBuhinSave.buildWorkBuhinStatusApplyEffectState(statusState);
    work.buhinSelected = statusEffectState.buhinSelected;

    if (statusEffectState.shouldChangeWorkStatus) {
      this.inspectService.changeWorkStatus(this.inspectDescriptionWorkAndBuhinData);
    } else if (statusEffectState.shouldSetWorkBuhinSelected) {
      this.workAndBuhinDataService.setWorkBuhinSelected(statusEffectState.workBuhinSelected);
    }
    if (statusEffectState.shouldRemoveEditMode) {
      this.removeEditMode();
    }
  }

  /**
   * 用途: restoreBuhinConfirmForDialog で確定状態や選択状態を復元/保持する。
   * WHY: dialog/ref 互換の状態遷移を component 側で固定するため。
   */
  restoreBuhinConfirmForDialog() {
    const restoreActionState = this.workAndBuhinDataService
      .buildRestoreBuhinConfirmForDialogAction(this.isDialog);
    const restoreEffectState = WorkBuhinConfirm.buildRestoreBuhinConfirmForDialogApplyEffectState(
      restoreActionState
    );
    if (restoreEffectState.shouldKeepBuhinConfirm) {
      this.keepBuhinConfirm(restoreEffectState.seibiList);
      this.keepBuhinConfirm(restoreEffectState.manualSeibiList);
    } else if (restoreEffectState.shouldKeepBuhinConfirmOsusume) {
      this.keepBuhinConfirmOsusume(restoreEffectState.osusumeData);
    }
  }

  /**
   * 用途: applyResetSeibiConfirmState の effect state を Vue state や副作用へ反映する。
   * WHY: helper の純粋判定と component の実反映を分けるため。
   */
  applyResetSeibiConfirmState(work: any) {
    const resetConfirmAction = WorkBuhinConfirm.buildResetSeibiConfirmActionState({
      isResetSeibi: this.isResetSeibi,
      work
    });
    const resetConfirmEffect = WorkBuhinConfirm.buildResetSeibiConfirmApplyEffectState(resetConfirmAction);
    if (!resetConfirmEffect.shouldApply) {
      return;
    }
    if (resetConfirmEffect.shouldCheckWorkBuhinSelected) {
      this.checkWorkBuhinSelected(work);
    }
    if (resetConfirmEffect.shouldClearConfirmValues) {
      this.$set(
        this.listBuhinConfirm,
        resetConfirmEffect.confirmKey,
        resetConfirmEffect.confirmValues
      );
    }
  }

  /**
   * 用途: 確定時の選択部品と work state を反映する。
   * WHY: helper の確定結果を Vue state へ戻す境界を明示するため。
   */
  commitBuhinConfirmState(work: any) {
    const commitConfirmAction = WorkBuhinConfirm.buildCommitBuhinConfirmActionState({
      work,
      isDialog: this.isDialog,
      tmpDeletedManualBuhinBuff: this.tmpDeletedManualBuhinBuff
    });
    const commitConfirmEffect = WorkBuhinConfirm.buildCommitBuhinConfirmApplyEffectState(commitConfirmAction);
    if (commitConfirmEffect.shouldCommitWorkConfirm) {
      this.workConfirm = this.utils.deepCopy(commitConfirmEffect.workConfirmSource);
    }
    if (commitConfirmEffect.shouldCommitDeletedManualBuhinList) {
      this.tmpDeletedManualBuhinList = this.utils.deepCopy(
        commitConfirmEffect.deletedManualBuhinListSource
      );
    }
  }

  /**
   * 用途: 親へ onconfirm payload を通知する。
   * WHY: 親向け event 契約を component 側で維持するため。
   */
  emitBuhinConfirm(status: number, changeList: any[]) {
    const emitActionState = this.workAndBuhinDataService.buildBuhinConfirmEmitActionState({
      status,
      seibi: this.getTargetWorkForBuhinSave(),
      isManualWork: this.isManualWork,
      changeList
    });
    const emitEffectState = WorkBuhinSave.buildBuhinConfirmEmitApplyEffectState(emitActionState);
    if (emitEffectState.shouldApplyDeletedStatus) {
      this.applyDeletedStatusForConfirmEmit(status);
    }
    if (emitEffectState.shouldEmit) {
      this.$emit(emitEffectState.eventName, emitEffectState.payload);
    }
  }

  /**
   * 用途: applyDeletedStatusForConfirmEmit の effect state を Vue state や副作用へ反映する。
   * WHY: helper の純粋判定と component の実反映を分けるため。
   */
  applyDeletedStatusForConfirmEmit(status: number) {
    const deletedStatus = WorkBuhinSave.resolveDeletedStatusForConfirmEmit({
      status,
      hasSeibiList: this.workAndBuhinDataService.hasSeibiList(),
      isManualWork: this.isManualWork
    });
    const deletedStatusEffect = WorkBuhinSave.buildDeletedStatusForConfirmEmitApplyEffectState(
      deletedStatus
    );
    if (!deletedStatusEffect.shouldApply) {
      return;
    }
    const deletedStatusTargetEffect =
      WorkBuhinSave.buildDeletedStatusForConfirmEmitTargetApplyEffectState({
        effectState: deletedStatusEffect,
        activeWorkIndex: this.activeWorkIndex
      });
    if (deletedStatusTargetEffect.shouldApplySeibiBuhinSelected) {
      this.workAndBuhinDataService.setSeibiBuhinSelected(
        deletedStatusTargetEffect.seibiBuhinSelectedIndex,
        deletedStatusTargetEffect.seibiBuhinSelected
      );
    }
    if (deletedStatusTargetEffect.shouldApplyManualSeibiBuhinSelected) {
      this.workAndBuhinDataService.setManualSeibiBuhinSelected(
        deletedStatusTargetEffect.manualSeibiBuhinSelectedIndex,
        deletedStatusTargetEffect.manualSeibiBuhinSelected
      );
    }
    if (deletedStatusTargetEffect.shouldApplyDataBuhinSelected) {
      this.workAndBuhinDataService.setBuhinSelected(deletedStatusTargetEffect.dataBuhinSelected);
    }
  }

  /**
   * 用途: addBuhinIsDelete で手入力作業/部品の追加処理を進める。
   * WHY: 入力、API 補完、state 反映の順序を component 側で保つため。
   */
  addBuhinIsDelete(list: BuhinDetail[]) {
    return WorkBuhinSave.addBuhinIsDelete(list);
  }

  /**
   * 用途: filterSeibi で表示対象の部品/作業を絞り込む。
   * WHY: template の一覧表示条件を component method に閉じ込めるため。
   */
  filterSeibi() {
    const cleanupState = this.workAndBuhinDataService.buildSeibiCleanupState();
    const cleanupEffectState = WorkBuhinSave.buildSeibiCleanupApplyEffectState(cleanupState);
    if (cleanupEffectState.shouldApplySeibiList) {
      this.workAndBuhinDataService.setSeibiList(cleanupEffectState.seibiList);
    }
    if (cleanupEffectState.shouldApplyManualSeibiList) {
      this.workAndBuhinDataService.setManualSeibiList(cleanupEffectState.manualSeibiList);
    }
  }

  /**
   * 用途: filterManualBuhin で表示対象の部品/作業を絞り込む。
   * WHY: template の一覧表示条件を component method に閉じ込めるため。
   */
  filterManualBuhin() {
    const filterState = WorkBuhinTab.buildManualBuhinFilterState(
      this.listManualBuhin,
      this.activeBuhinCateIndex,
      this.buhinCategory
    );
    const filterEffectState = WorkBuhinTab.buildManualBuhinFilterApplyEffectState(filterState);
    const filterCommitEffectState =
      WorkBuhinTab.buildManualBuhinFilterCommitApplyEffectState(filterEffectState);
    this.applyManualBuhinFilterCommitEffectState(filterCommitEffectState);
  }

  /*
   * applyManualBuhinFilterCommitEffectState を filterManualBuhin() から分離し、
   * 手入力部品 filter 後の listManualBuhinFiltered 反映を一箇所に寄せるため。
   */
  applyManualBuhinFilterCommitEffectState(
    effectState: WorkBuhinTab.ManualBuhinFilterCommitApplyEffectState
  ) {
    this.$set(
      this,
      "listManualBuhinFiltered",
      effectState.listManualBuhinFiltered
    );
  }

  /**
   * 用途: resetBuhin で確定状態や選択状態を復元/保持する。
   * WHY: dialog/ref 互換の状態遷移を component 側で固定するため。
   */
  resetBuhin() {
    const resetState = WorkBuhinPublicApi.buildResetBuhinPublicState();
    const resetEffectState = WorkBuhinPublicApi.buildResetBuhinApplyEffectState(resetState);
    const resetCommitEffectState =
      WorkBuhinPublicApi.buildResetBuhinCommitApplyEffectState(resetEffectState);
    this.applyResetBuhinCommitEffectState(resetCommitEffectState);
  }

  /*
   * applyResetBuhinCommitEffectState を resetBuhin() から分離し、
   * public reset 後の list 反映と mapBuhin 実行を一箇所に寄せるため。
   */
  applyResetBuhinCommitEffectState(effectState: WorkBuhinPublicApi.ResetBuhinCommitApplyEffectState) {
    this.$set(this, "listSelectedBuhin", effectState.listSelectedBuhin);
    this.$set(
      this,
      "listManualBuhinFiltered",
      effectState.listManualBuhinFiltered
    );
    if (effectState.shouldMapBuhin) {
      this.mapBuhin();
    }
  }

  /**
   * 用途: mapBuhin で WorkAndBuhin の画面状態を処理する。
   * WHY: 既存 template/ref 互換を維持しながら責務境界を明示するため。
   */
  mapBuhin() {
    const hasBuhinData = this.listBuhinData.length > 0;
    const selectedMapSourceState = WorkBuhinDisplay.buildSelectedBuhinMapSourceState({
      hasBuhinData,
      selectedBuhinLength: this.listSelectedBuhin.length,
      activeBuhinCateIndex: this.activeBuhinCateIndex,
      buhinCategory: this.buhinCategory
    });
    const selectedWork = selectedMapSourceState.shouldResolveSelectedWork
      ? this.getWork()
      : null;
    const selectedMapState = WorkBuhinDisplay.buildSelectedBuhinMapActionState({
      hasBuhinData,
      buhinContent: this.utils.deepCopy(selectedMapSourceState.buhinContentSource),
      selectedBuhinList: this.listSelectedBuhin,
      activeBuhinShubetsuId: this.activeBuhinShubetsuId,
      freeOfChargeBuhinList: this.freeOfChargeBuhinList,
      seibiNm: selectedWork && selectedWork.seibiNm
    });
    if (!selectedMapState.shouldContinue) {
      return;
    }
    const selectedMapEffectState = WorkBuhinDisplay.buildSelectedBuhinMapApplyEffectState(
      selectedMapState
    );
    if (selectedMapEffectState.shouldResetFirstBuhinCd) {
      this.firstBuhinCd = selectedMapEffectState.resetFirstBuhinCd;
    }

    if (selectedMapEffectState.shouldApplySelectedBuhin) {
      this.firstBuhinCd = selectedMapEffectState.firstBuhinCd;
      this.$set(this, "buhinContent", this.filterButteryBuhin(selectedMapEffectState.buhinContent));
      if (selectedMapEffectState.shouldSetFilterBuhin) {
        this.setFilterBuhin(selectedMapEffectState.selFilter);
      }
    } else if (selectedMapEffectState.shouldRunDelayedMap) {
      setTimeout(() => {
        const delayedSourceState = WorkBuhinDisplay.buildUnselectedBuhinMapDelayedSourceState({
          listBuhinData: this.listBuhinData
        });
        const delayedSourceEffectState =
          WorkBuhinDisplay.buildUnselectedBuhinMapDelayedSourceApplyEffectState(delayedSourceState);
        if (!delayedSourceEffectState.shouldBuildDelayedMap) {
          return;
        }
        const buhinCategory = this.utils.deepCopy(
          delayedSourceEffectState.latestBuhinCategorySource
        );
        const work = delayedSourceEffectState.shouldResolveWork ? this.getWork() : null;
        const displayState = WorkBuhinDisplay.buildUnselectedBuhinMapDelayedActionState({
          latestBuhinCategory: buhinCategory,
          activeBuhinCateIndex: this.activeBuhinCateIndex,
          freeOfChargeBuhinList: this.freeOfChargeBuhinList,
          seibiNm: work && work.seibiNm
        });
        const displayEffectState = WorkBuhinDisplay.buildUnselectedBuhinMapDelayedApplyEffectState(
          displayState
        );
        if (displayEffectState.shouldApply) {
          this.$set(this, "buhinCategory", displayEffectState.buhinCategory);
          this.$set(this, "activeCateBuhins", displayEffectState.activeCateBuhins);
          this.$set(this, "buhinContent", this.filterButteryBuhin(displayEffectState.buhinContent));
          if (displayEffectState.shouldSetFilterBuhin) {
            this.setFilterBuhin(displayEffectState.selFilter);
          }
        }
      }, 10);
    }
  }
  /**
   * 用途: scrollToBuhin で WorkAndBuhin の画面状態を処理する。
   * WHY: 既存 template/ref 互換を維持しながら責務境界を明示するため。
   */
  scrollToBuhin(timeout = 100) {
    const targetState = WorkBuhinDisplay.buildBuhinScrollTargetState({
      firstBuhinCd: this.firstBuhinCd,
      listManualBuhinFilteredLength: this.listManualBuhinFiltered.length
    });
    const lookupState = WorkBuhinDisplay.buildBuhinScrollElementLookupState(targetState);
    const buhinEle: any = lookupState.shouldGetElementById
      ? document.getElementById(lookupState.elementId)
      : lookupState.shouldQuerySelector
        ? document.querySelector(lookupState.selector)
        : null;
    setTimeout(() => {
      const retryState = WorkBuhinDisplay.buildBuhinScrollRetryActionState({
        hasElement: !!buhinEle,
        shouldScroll: targetState.shouldScroll,
        nRetryScroll: this.nRetryScroll
      });
      const retryEffectState = WorkBuhinDisplay.buildBuhinScrollRetryApplyEffectState(retryState);
      if (retryEffectState.shouldScrollIntoView) {
        buhinEle.scrollIntoView();
        this.nRetryScroll = retryEffectState.nRetryScroll;
      } else if (retryEffectState.shouldRetry) {
        this.nRetryScroll = retryEffectState.nRetryScroll;
        this.scrollToBuhin(retryEffectState.retryTimeout);
      }
    }, timeout);
  }

  /**
   * 用途: setFilterBuhin で選択状態や表示状態を更新する。
   * WHY: template/event からの更新入口を明示し、service/helper 境界を保つため。
   */
  setFilterBuhin(listSelFilter: any) {
    const activeCategorySourceState = WorkBuhinDisplay.buildActiveBuhinCategorySourceState({
      buhinCategory: this.buhinCategory,
      activeBuhinCateIndex: this.activeBuhinCateIndex
    });
    const filterState = WorkBuhinDisplay.buildBuhinFilterApplyActionState({
      listSelFilter,
      activeBuhinCateIndex: this.activeBuhinCateIndex,
      defualtBuhinShubetsuIndex: this.defualtBuhinShubetsuIndex,
      defualtBuhinBunruiCdList: this.defualtBuhinBunruiCdList,
      sourceBuhinContent: activeCategorySourceState.sourceBuhinContent,
      activeCateBuhins: this.activeCateBuhins,
      selectedBuhinList: this.listSelectedBuhin,
      freeOfChargeBuhinList: this.freeOfChargeBuhinList
    });
    const filterEffectState = WorkBuhinDisplay.buildBuhinFilterApplyEffectState(filterState);
    this.$set(this, "selFilter", filterEffectState.selFilter);
    if (filterEffectState.shouldApplyBuhinContent) {
      this.$set(this, "buhinContent", this.filterButteryBuhin(filterEffectState.buhinContent));
    }
  }

  /**
   * 用途: onClose で UI event や親 event を受けて処理を開始する。
   * WHY: 画面操作の入口と helper/service 呼び出しを明確に分けるため。
   */
  onClose() {
    const closeActionState = WorkBuhinClose.buildWorkBuhinCloseActionState({
      isChange: this.isChange,
      isSocket: this.isSocket,
      isResetSeibi: this.isResetSeibi
    });
    const closeEffectState = WorkBuhinClose.buildWorkBuhinCloseApplyEffectState(closeActionState);
    this.showConfirmDialog2 = closeEffectState.showConfirmDialog2;
    this.workAndBuhinDataService.setShowWork(closeEffectState.showWork);
    if (closeEffectState.shouldRemoveEditMode) {
      this.removeEditMode();
    }
    // 2024-09-18 maki 部品なしで確定時、手入力部品、純正部品が削除されない [start]
    // [メモ]
    // 事前見積、現車、57項目で部品削除時、配列空ではなく、isDelete=1でBE送信が必要なので関数呼び出しをコメントアウト
    // 作業部品選択では必要な処理かもしれないが、機能封印環境で修正したため、動作確認が出来ない
    // if (closeEffectState.shouldFilterSeibi) {
    //   this.filterSeibi();
    // }
    // 2024-09-18 maki 部品なしで確定時、手入力部品、純正部品が削除されない [end]
    if (closeEffectState.shouldEmitOnClose) {
      this.$emit("onclose", closeEffectState.payload);
    }
  }

  /**
   * 用途: setRecommendBuhinSelected で選択状態や表示状態を更新する。
   * WHY: template/event からの更新入口を明示し、service/helper 境界を保つため。
   */
  setRecommendBuhinSelected(buhin: BuhinDetail, isSelected: boolean) {
    const selectedState =
      this.workAndBuhinDataService.buildRecommendBuhinSelectedState(isSelected);
    const selectedEffectState = WorkBuhinSelection.buildRecommendBuhinSelectedApplyEffectState(
      selectedState
    );
    if (selectedEffectState.shouldApply) {
      this.$set(buhin, "isSelected", selectedEffectState.isSelected);
    }
  }

  /**
   * 用途: onBuhinClick で UI event や親 event を受けて処理を開始する。
   * WHY: 画面操作の入口と helper/service 呼び出しを明確に分けるため。
   */
  onBuhinClick(buhin: BuhinDetail, event: any) {
    const clickActionState = WorkBuhinQuantity.buildNormalBuhinClickActionState({
      disabledBtnNoBuhin: this.disabledBtnNoBuhin,
      isChecked: event.target.checked,
      defaultQuantity: buhin.defaultQuantity
    });
    const clickEffectState = WorkBuhinQuantity.buildNormalBuhinClickApplyEffectState(clickActionState);
    if (clickEffectState.shouldPreventDefault) {
      event.preventDefault();
      return;
    }
    if (clickEffectState.shouldUpdateQuantity) {
      this.$set(buhin, "quantity", clickEffectState.quantity);
    }
    if (clickEffectState.shouldSyncSelection) {
      const isSelected = WorkBuhinQuantity.syncNormalBuhinSelection(this.listSelectedBuhin, buhin);
      if (clickEffectState.shouldUpdateRecommendBuhinSelected) {
        this.setRecommendBuhinSelected(buhin, isSelected);
      }
    }
    if (clickEffectState.shouldCheckDisabledBtnConfirm) {
      this.checkDisabledBtnConfirm();
    }
  }

  /**
   * 用途: onQuantityInput で UI event や親 event を受けて処理を開始する。
   * WHY: 画面操作の入口と helper/service 呼び出しを明確に分けるため。
   */
  getQuantityDecimalPlaces(buhin: BuhinDetail) {
    return WorkBuhinQuantity.getQuantityDecimalPlaces(buhin);
  }

  onQuantityInput(buhin: BuhinDetail) {
    const inputActionState = WorkBuhinQuantity.buildNormalBuhinQuantityInputActionState();
    const inputEffectState = WorkBuhinQuantity.buildNormalBuhinQuantityInputApplyEffectState(
      inputActionState
    );
    if (inputEffectState.shouldSyncSelection) {
      const isSelected = WorkBuhinQuantity.syncNormalBuhinSelection(this.listSelectedBuhin, buhin);
      if (inputEffectState.shouldUpdateRecommendBuhinSelected) {
        this.setRecommendBuhinSelected(buhin, isSelected);
      }
    }
    if (inputEffectState.shouldCheckDisabledBtnConfirm) {
      this.checkDisabledBtnConfirm();
    }
  }

  /**
   * 用途: onQuantityInputManual で UI event や親 event を受けて処理を開始する。
   * WHY: 画面操作の入口と helper/service 呼び出しを明確に分けるため。
   */
  onQuantityInputManual(buhin: BuhinDetail) {
    const inputActionState = WorkBuhinQuantity.buildManualBuhinQuantityInputActionState();
    const inputEffectState = WorkBuhinQuantity.buildManualBuhinQuantityInputApplyEffectState(
      inputActionState
    );
    if (inputEffectState.shouldSyncSelection) {
      WorkBuhinQuantity.syncManualOrJunseiBuhinSelection(this.listSelectedBuhin, buhin);
    }
    if (inputEffectState.shouldCheckDisabledBtnConfirm) {
      this.checkDisabledBtnConfirm();
    }
  }

  /**
   * 用途: buhinChangePrice で WorkAndBuhin の画面状態を処理する。
   * WHY: 既存 template/ref 互換を維持しながら責務境界を明示するため。
   */
  onManualBuhinNameInput() {
    this.hasPendingBuhinEdit = true;
    this.hasExplicitBuhinEdit = true;
  }

  buhinChangePrice(buhin: BuhinDetail, isManual: boolean = false) {
    this.hasPendingBuhinEdit = true;
    const priceChangeActionState = WorkBuhinEdit.buildBuhinPriceChangeActionState({
      buhin,
      isManual,
      isDialog: this.isDialog,
      workBeforeChange: this.workBeforeChange,
      selectedBuhinList: this.listSelectedBuhin
    });
    const priceChangeEffectState = WorkBuhinEdit.buildBuhinPriceChangeApplyEffectState(priceChangeActionState);
    if (priceChangeEffectState.shouldApplySelectedBuhinPrice) {
      const itemIndex = priceChangeEffectState.selectedBuhinIndex;
      this.listSelectedBuhin[itemIndex].buhinPriceZn =
        priceChangeEffectState.selectedBuhinPrice;
    }
    if (priceChangeEffectState.shouldApplyPriceChange) {
      // MD-0015 (作業・部品選択)
      this.buhinChangeList[priceChangeEffectState.buhinChangeId] =
        priceChangeEffectState.buhinChangeEntry;
    }
  }

  /**
   * 用途: onEditResult で UI event や親 event を受けて処理を開始する。
   * WHY: 画面操作の入口と helper/service 呼び出しを明確に分けるため。
   */
  onEditResult(event: any, work: any) {
    const editResultActionState = WorkBuhinEdit.buildEditResultActionState(work);
    const editResultEffectState = WorkBuhinEdit.buildEditResultApplyEffectState(editResultActionState);
    if (editResultEffectState.shouldStopPropagation) {
      event.stopPropagation();
    }
    if (editResultEffectState.shouldEmitOnEditResult) {
      this.$emit(editResultEffectState.eventName, editResultEffectState.payload);
    }
  }

  /**
   * 用途: onSelectExtremeTab で UI event や親 event を受けて処理を開始する。
   * WHY: 画面操作の入口と helper/service 呼び出しを明確に分けるため。
   */
  onSelectExtremeTab() {
    const extremeTabState = WorkBuhinTab.buildExtremeTabApplyActionState(this.listBuhinActiveSeibi);
    const extremeTabEffectState = WorkBuhinTab.buildExtremeTabApplyEffectState(extremeTabState);
    this.$set(this, "activeBuhinCateIndex", extremeTabEffectState.activeBuhinCateIndex);
    this.$set(this, "activeCateBuhins", extremeTabEffectState.activeCateBuhins);
    this.$set(this, "listManualBuhinFiltered", extremeTabEffectState.listManualBuhinFiltered);
    this.$set(this, "activeBuhinShubetsuId", extremeTabEffectState.activeBuhinShubetsuId);
    if (extremeTabEffectState.shouldFilterManualBuhin) {
      this.filterManualBuhin();
    }
    if (extremeTabEffectState.shouldApplyBuhinContent) {
      this.$set(this, "buhinContent", extremeTabEffectState.buhinContent);
    }
  }


  /**
   * 用途: 型式情報から日整連作業/純正部品を取得する。
   * WHY: API と loading の副作用境界を component に残すため。
   */
  getNisseirenJunseiByKatashiki() {
    if (this.hideNisseirenJunsei) { return; }
    const katashikiParams = this.katashikiService.getKatashikiParams();
    const loadStartEffectState = WorkBuhinNisseiren.buildNisseirenJunseiLoadStartApplyEffectState(
      this.workAndBuhinDataService.shouldLoadNisseirenJunsei({
        isUseNisseiren: this.isUseNisseiren,
        katashikiParams
      })
    );
    if (!loadStartEffectState.shouldLoadNisseirenJunsei) {
      return;
    }
    if (loadStartEffectState.shouldSetLoading) {
      this.$set(this, "loading", loadStartEffectState.loading);
    }
    // ストアから日整連作業を取得
    let nisseirenWorkPromise;
    const cachedNisseirenWork: any = this.getNisseirenWorkStoreByKatashiki(
      WorkBuhinNisseiren.getNisseirenWorkStoreKey(
        katashikiParams,
        this.uketsukeExtendsId,
        this.workAndBuhinDataService.getSknInspectDescriptionId()
      )
    );
    let cachedJunseiBuhin: any;
    if (this.isUseJunseiBuhin) {
      cachedJunseiBuhin = this.getJunseiBuhinStoreByKatashiki(
        WorkBuhinNisseiren.getJunseiBuhinStoreKey(
          katashikiParams,
          this.workAndBuhinDataService.getSknInspectDescriptionId()
        ) as string[]
      );
    }
    const cachedSearchState = WorkBuhinNisseiren.buildNisseirenJunseiCachedSearchState({
      cachedNisseirenWork,
      cachedJunseiBuhin,
      isUseJunseiBuhin: this.isUseJunseiBuhin
    });
    let nisseirenWork: any = cachedSearchState.nisseirenWork;
    let junseiBuhin: any = cachedSearchState.junseiBuhin;
    if (cachedSearchState.shouldRequestNisseirenWork) {
      // ストアから取得できなかった場合は検索する ※空配列チェックはしない（空配列＝検索結果0件のキャッシュなので）
      nisseirenWorkPromise = WorkBuhinNisseirenApi.fetchNisseirenWorkByKatashiki(this.reqService, {
        katashikiParams,
        uketsukeExtendsId: this.uketsukeExtendsId,
        sknInspectDescriptionId: this.workAndBuhinDataService.getSknInspectDescriptionId(),
        sknSeibiShubetsuKbn: this.currentState.sknUketsukeExtends.sknSeibiShubetsuKbn || 0
      }).then((result: any) => {
        nisseirenWork = result;
      }).then(() => {
        const storeEffectState = WorkBuhinNisseiren.buildNisseirenWorkStoreApplyEffectState({
          shouldRequestNisseirenWork: cachedSearchState.shouldRequestNisseirenWork,
          katashikiParams,
          uketsukeExtendsId: this.uketsukeExtendsId,
          sknInspectDescriptionId: this.workAndBuhinDataService.getSknInspectDescriptionId(),
          nisseirenWork
        });
        if (storeEffectState.shouldSetStore) {
          this.setNisseirenWorkStoreByKatashiki(storeEffectState.storePayload);
        }
      });
    }

    // ストアから純正部品を取得
    let junseiBuhinPromise;
    if (cachedSearchState.shouldRequestJunseiBuhin) {
      // ストアから取得できなかった場合は検索する ※空配列チェックはしない（空配列＝検索結果0件のキャッシュなので）
      junseiBuhinPromise = WorkBuhinNisseirenApi.fetchJunseiBuhinByKatashiki(this.reqService, {
        katashikiParams,
        sknInspectDescriptionId: this.workAndBuhinDataService.getSknInspectDescriptionId()
      }).then((result: any) => {
        junseiBuhin = result;
      }).then(() => {
        const storeEffectState = WorkBuhinNisseiren.buildJunseiBuhinStoreApplyEffectState({
          shouldRequestJunseiBuhin: cachedSearchState.shouldRequestJunseiBuhin,
          katashikiParams,
          sknInspectDescriptionId: this.workAndBuhinDataService.getSknInspectDescriptionId(),
          junseiBuhin
        });
        if (storeEffectState.shouldSetStore) {
          this.setJunseiBuhinStoreByKatashiki(storeEffectState.storePayload);
        }
      });
    }

    return Promise.all([nisseirenWorkPromise, junseiBuhinPromise]).then(() => {
      const loadedApplyState = WorkBuhinNisseiren.buildNisseirenJunseiLoadedApplyActionState({
        isUseJunseiBuhin: this.isUseJunseiBuhin,
        listManualBuhin: this.listManualBuhin,
        nisseirenWork,
        junseiBuhin
      });
      const loadedEffectState = WorkBuhinNisseiren.buildNisseirenJunseiLoadedApplyEffectState(loadedApplyState);
      if (loadedEffectState.shouldApplyNisseirenWork) {
        this.setFoundNisseirenWork(loadedEffectState.nisseirenWork);
      }
      if (loadedEffectState.shouldScrollNisseirenWork) {
        this.scrollTobottom(loadedEffectState.nisseirenWorkScrollTargetId);
      }
      if (loadedEffectState.shouldApplyJunseiBuhin) {
        this.setFoundJunseiBuhin(loadedEffectState.junseiBuhin);
      }
      if (loadedEffectState.shouldScrollJunseiBuhin) {
        this.scrollTobottom(loadedEffectState.junseiBuhinScrollTargetId);
      }
      if (loadedEffectState.shouldSelectJunseiTab) {
        this.onSelectJunseiTab();
      }
      if (loadedEffectState.shouldSetLoading) {
        this.$set(this, "loading", loadedEffectState.loading);
      }
    });
  }

  /**
   * 用途: 日整連作業から純正部品を取得する。
   * WHY: 選択作業に紐づく API 反映順を component 側で保つため。
   */
  getJunseiBuhinByNisseirenWork(sknNisseirenCd: any) {
    const katashikiParams = this.katashikiService.getKatashikiParams();
    const requestParams = {
      katashikiParams,
      sknNisseirenCd
    };

    const loadStartEffectState = WorkBuhinNisseiren.buildNisseirenJunseiLoadStartApplyEffectState(true);
    if (loadStartEffectState.shouldSetLoading) {
      this.$set(this, "loading", loadStartEffectState.loading);
    }
    WorkBuhinNisseirenApi.fetchJunseiBuhinByNisseirenWork(this.reqService, requestParams).then((result: any) => {
      const applyActionState = WorkBuhinNisseiren.buildJunseiBuhinByNisseirenWorkApplyActionState(result);
      const applyEffectState = WorkBuhinNisseiren.buildJunseiBuhinByNisseirenWorkApplyEffectState(
        applyActionState
      );
      if (applyEffectState.shouldApplyJunseiBuhin) {
        this.setFoundJunseiBuhin(applyEffectState.junseiBuhin);
      }
      if (applyEffectState.shouldScrollJunseiBuhin) {
        this.scrollTobottom(applyEffectState.junseiBuhinScrollTargetId);
      }
    }).then(() => {
      const afterEffectState = WorkBuhinNisseiren.buildJunseiBuhinByNisseirenWorkAfterApplyEffectState();
      if (afterEffectState.shouldSetLoading) {
        this.$set(this, "loading", afterEffectState.loading);
      }
      if (afterEffectState.shouldSelectJunseiTab) {
        this.onSelectJunseiTab();
      }
    });
  }

  /**
   * 用途: 純正部品タブ選択
   * WHY: 既存の関数説明を block comment 形式に揃えるため。
   */
  onSelectJunseiTab() {
    const junseiTabState = WorkBuhinNisseiren.buildJunseiTabState(
      this.listManualBuhin,
      this.listSelectedBuhin
    );
    const junseiTabEffectState = WorkBuhinNisseiren.buildJunseiTabApplyEffectState(junseiTabState);
    this.$set(this, "activeBuhinCateIndex", junseiTabEffectState.activeBuhinCateIndex);
    this.$set(this, "activeCateBuhins", junseiTabEffectState.activeCateBuhins);
    this.$set(this, "activeBuhinShubetsuId", junseiTabEffectState.activeBuhinShubetsuId);
    if (junseiTabEffectState.shouldApplyBuhinContent) {
      this.$set(this, "buhinContent", junseiTabEffectState.buhinContent);
    }
    if (junseiTabEffectState.shouldApplyManualBuhinFiltered) {
      this.$set(this, "listManualBuhinFiltered", junseiTabEffectState.listManualBuhinFiltered);
    }
    if (junseiTabEffectState.shouldAutoSelectBuhin) {
      this.listSelectedBuhin.push(junseiTabEffectState.autoSelectBuhin);
    }
  }

  /**
   * 用途: onSelectOsusumeTab で UI event や親 event を受けて処理を開始する。
   * WHY: 画面操作の入口と helper/service 呼び出しを明確に分けるため。
   */
  onSelectOsusumeTab() {
    const extremeMasterState = WorkBuhinTab.buildExtremeBuhinMasterState(this.listBuhinActiveSeibi);
    const osusumeTabState = WorkBuhinTab.buildOsusumeTabApplyActionState({
      osusumeBuhinList: this.osusumeBuhinList,
      selectedBuhinLength: this.listSelectedBuhin.length,
      listExtreme: extremeMasterState.listExtreme,
      isDialog: this.isDialog,
      workBeforeChange: this.workBeforeChange,
      listSelectedBuhin: this.listSelectedBuhin
    });
    const osusumeTabEffectState = WorkBuhinTab.buildOsusumeTabApplyEffectState(osusumeTabState);
    this.$set(this, "activeBuhinCateIndex", osusumeTabEffectState.activeBuhinCateIndex);
    if (osusumeTabEffectState.shouldApplyActiveCateBuhins) {
      this.$set(this, "activeCateBuhins", osusumeTabEffectState.activeCateBuhins);
    }
    if (osusumeTabEffectState.shouldAppendSelectedBuhin) {
      osusumeTabEffectState.selectedBuhinToAppend.forEach((b: any) => {
        this.listSelectedBuhin.push(b);
      });
    }
    if (osusumeTabEffectState.shouldApplyBuhinContent) {
      this.$set(this, "buhinContent", osusumeTabEffectState.buhinContent);
    } else if (osusumeTabEffectState.shouldSelectExtremeTab) {
      this.onSelectExtremeTab();
    } else if (osusumeTabEffectState.shouldSelectBuhinShubetsu) {
      let buhinShubetsuCd = this.findBuhinShubetsuCd(
        osusumeTabEffectState.fallbackBuhinShubetsuId
      );
      this.selectBuhinShubetsu(buhinShubetsuCd, this.listSelectedBuhin);
    } else if (osusumeTabEffectState.shouldApplyFallbackBuhinContent) {
      this.$set(this, "buhinContent", osusumeTabEffectState.buhinContent);
    }
    if (osusumeTabEffectState.shouldClearManualBuhinFiltered) {
      this.$set(
        this,
        "listManualBuhinFiltered",
        osusumeTabEffectState.listManualBuhinFiltered
      );
    }
    if (osusumeTabEffectState.shouldFilterManualBuhin) {
      this.filterManualBuhin();
    }
  }

  /**
   * 用途: changeEditMode で WorkAndBuhin の画面状態を処理する。
   * WHY: 既存 template/ref 互換を維持しながら責務境界を明示するため。
   */
  changeEditMode(e: any, work: any) {
    e.stopPropagation();
    const editModeChange = WorkBuhinEdit.resolveEditModeChange({
      work,
      disabledBtnNoBuhin: this.disabledBtnNoBuhin,
      currentBuhinChangeEntry: this.buhinChangeList[work.id]
    });
    const editModeEffectState = WorkBuhinEdit.buildEditModeChangeApplyEffectState(editModeChange);
    if (editModeEffectState.shouldUpdate) {
      if (editModeEffectState.shouldSetIsChange) {
        this.isChange = true;
      }
      work.editMode = editModeEffectState.editMode;
      if (editModeEffectState.shouldApplyBuhinChangeEntry) {
        this.buhinChangeList[work.id] = editModeEffectState.buhinChangeEntry;
      }
      if (editModeEffectState.shouldForceUpdate) {
        this.$forceUpdate();
      }
    }
  }

  /**
   * 用途: removeEditMode で作業/部品の削除処理を開始する。
   * WHY: dialog state と削除反映の順序を component 側で固定するため。
   */
  removeEditMode() {
    this.workAndBuhinDataService.removeEditMode();
  }

  /**
   * 用途: keepBuhinConfirm で確定状態や選択状態を復元/保持する。
   * WHY: dialog/ref 互換の状態遷移を component 側で固定するため。
   */
  keepBuhinConfirm(seibiList: any) {
    const entriesEffectState = WorkBuhinConfirm.buildBuhinConfirmEntriesApplyEffectState(
      WorkBuhinConfirm.buildBuhinConfirmEntries(seibiList)
    );
    if (entriesEffectState.shouldApplyEntries) {
      entriesEffectState.entries.forEach((entry: any) => {
        this.listBuhinConfirm[entry.key] = entry.values;
      });
    }
  }

  /**
   * 用途: keepBuhinConfirmOsusume で確定状態や選択状態を復元/保持する。
   * WHY: dialog/ref 互換の状態遷移を component 側で固定するため。
   */
  keepBuhinConfirmOsusume(seibi: any, isInit: boolean = false) {
    const entryEffectState = WorkBuhinConfirm.buildOsusumeBuhinConfirmEntryApplyEffectState(
      WorkBuhinConfirm.buildOsusumeBuhinConfirmEntry(seibi, isInit)
    );
    if (entryEffectState.shouldApplyEntry && entryEffectState.entry) {
      this.listBuhinConfirm[entryEffectState.entry.key] = entryEffectState.entry.values;
    }
  }

  /**
   * 用途: isBuhinConfirm で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  isBuhinConfirm(buhin: BuhinDetail) {
    const key = this.workAndBuhinDataService.getActiveBuhinConfirmKey({
      activeSeibiId: this.activeSeibiId,
      isManualWork: this.isManualWork,
      activeWorkIndex: this.activeWorkIndex
    });
    return WorkBuhinConfirm.isBuhinConfirmedByKey(this.listBuhinConfirm, key, buhin);
  }

  /**
   * 用途: MD-0015 向けの確定状態を保持する。
   * WHY: 作業・部品選択の既存保存互換を維持するため。
   */
  onkeepBuhinMD15(data: any = null) {
    const keepConfirmActionState = this.workAndBuhinDataService
      .buildKeepBuhinConfirmMd15ActionState({
        isDialog: this.isDialog,
        data
      });
    const keepConfirmEffectState = WorkBuhinConfirm.buildKeepBuhinConfirmMd15ApplyEffectState(
      keepConfirmActionState
    );
    if (keepConfirmEffectState.shouldClearConfirmMap) {
      Object.keys(this.listBuhinConfirm).forEach((item: any, key: any) => {
        this.$set(this.listBuhinConfirm, key, []);
      }, this);
    }
    if (keepConfirmEffectState.shouldKeepBuhinConfirm) {
      this.keepBuhinConfirm(keepConfirmEffectState.seibiList);
      this.keepBuhinConfirm(keepConfirmEffectState.manualSeibiList);
    } else if (keepConfirmEffectState.shouldKeepBuhinConfirmOsusume) {
      this.keepBuhinConfirmOsusume(keepConfirmEffectState.osusumeData);
    }
  }

  /**
   * 用途: 削除確認ダイアログの「はい」押下時
   * WHY: 既存の関数説明を block comment 形式に揃えるため。
   */
  onConfirmDelete() {
    if (this.tmpResetWorkIndex > -1) {
      // 通常作業/おすすめ整備の削除
      const deleteResetActionState = this.workAndBuhinDataService.buildDeleteResetWorkActionState({
        activeWorkIndex: this.activeWorkIndex,
        isManualWork: this.isManualWork
      });
      const deleteResetEffectState = WorkBuhinDelete.buildDeleteResetWorkApplyEffectState(
        deleteResetActionState
      );
      const deleteResetCommitEffectState =
        WorkBuhinDelete.buildDeleteResetWorkCommitApplyEffectState(deleteResetEffectState);
      this.applyDeleteResetWorkCommitEffectState(deleteResetCommitEffectState);
    } else if (this.tmpDeleteWorkIndex > -1) {
      // 手入力作業の削除
      const deleteState = WorkBuhinDelete.deleteManualWorkFromList({
        manualSeibiList: this.workAndBuhinDataService.getManualSeibiList(),
        deleteIndex: this.tmpDeleteWorkIndex,
        activeWorkIndex: this.activeWorkIndex,
        isManualWork: this.isManualWork,
        seibiList: this.workAndBuhinDataService.getSeibiList(),
        isDialog: this.isDialog
      });
      const deleteActionState = WorkBuhinDelete.buildManualWorkDeleteActionState({
        deleteState,
        uketsukeExtendsId: this.uketsukeExtendsId,
        sknUketsukeInspectId: this.workAndBuhinDataService.getSknUketsukeInspectId()
      });
      const deleteEffectState = WorkBuhinDelete.buildManualWorkDeleteApplyEffectState({
        deleteState,
        actionState: deleteActionState
      });
      if (deleteEffectState.shouldDeleteManualSeibi) {
        this.reqService
          .deleteManualSeibi(deleteEffectState.deleteManualSeibiPayload)
          .then(() => {
            const deleteSuccessEffectState = WorkBuhinDelete.buildManualWorkDeleteSuccessApplyEffectState(
              deleteEffectState
            );
            if (deleteSuccessEffectState.shouldEmitCallbackDeleteManualSeibi) {
              this.$emit(
                deleteSuccessEffectState.callbackDeleteManualSeibiEventName,
                deleteSuccessEffectState.callbackDeleteManualSeibiInspectId
              );
            }
          });
      }
      const callbackBuhinEffectState = this.workAndBuhinDataService
        .buildManualWorkDeleteCallbackBuhinApplyEffectState(deleteEffectState);
      const deleteCommitEffectState = WorkBuhinDelete.buildManualWorkDeleteCommitApplyEffectState({
        effectState: deleteEffectState,
        callbackBuhinEffectState
      });
      this.applyManualWorkDeleteCommitEffectState(deleteCommitEffectState);
    } else if (this.tmpDeletedBuhin != null) {
      // 手入力部品および純正部品の削除
      const deleteStartEffectState = WorkBuhinDelete.buildManualBuhinDeleteStartApplyEffectState();
      if (deleteStartEffectState.shouldRemoveManualOrJunseiBuhin) {
        WorkBuhinManual.removeManualOrJunseiBuhin(this.listManualBuhin, this.tmpDeletedBuhin);
      }
      const deleteState = this.workAndBuhinDataService.buildManualBuhinDeleteState({
        activeWorkIndex: this.activeWorkIndex,
        isManualWork: this.isManualWork,
        listManualBuhin: this.listManualBuhin,
        deletedBuhin: this.tmpDeletedBuhin,
        isDialog: this.isDialog
      });
      const deleteEffectState = WorkBuhinDelete.buildManualBuhinDeleteApplyEffectState(deleteState);
      if (deleteEffectState.shouldFilterManualBuhin) {
        this.filterManualBuhin();
      }
      const deleteApiEffectState = WorkBuhinDelete.buildManualBuhinDeleteApiApplyEffectState(
        deleteEffectState
      );
      if (deleteApiEffectState.shouldDeleteManualBuhin) {
        this.reqService.deleteManualBuhin(deleteApiEffectState.deleteManualBuhinId);
        // 削除リストの退避
        if (deleteApiEffectState.shouldPushDeletedManualBuhinBuff) {
          this.tmpDeletedManualBuhinBuff.push(deleteApiEffectState.deletedManualBuhinKey);
        }
      }
      const deleteAfterEffectState = this.workAndBuhinDataService
        .buildManualBuhinDeleteAfterApplyEffectState(deleteEffectState);
      const deleteAfterCommitEffectState =
        WorkBuhinDelete.buildManualBuhinDeleteAfterCommitApplyEffectState(deleteAfterEffectState);
      this.applyManualBuhinDeleteAfterCommitEffectState(deleteAfterCommitEffectState);
    }
  }

  /*
   * applyDeleteResetWorkCommitEffectState を onConfirmDelete() から分離し、
   * 通常作業/おすすめ整備削除確定後の reset state 適用条件を一箇所に寄せるため。
   */
  applyDeleteResetWorkCommitEffectState(
    effectState: WorkBuhinDelete.DeleteResetWorkCommitApplyEffectState
  ) {
    if (effectState.shouldApplyWorkResetState) {
      this.applyWorkResetState(effectState.resetState);
    }
  }

  /*
   * applyManualWorkDeleteCommitEffectState を onConfirmDelete() から分離し、
   * 手入力作業削除後の画面 state、map、callbackDeleteBuhin emit の即時反映順を一箇所に寄せるため。
   */
  applyManualWorkDeleteCommitEffectState(
    effectState: WorkBuhinDelete.ManualWorkDeleteCommitApplyEffectState
  ) {
    this.activeWorkIndex = effectState.activeWorkIndex;
    if (effectState.shouldChangeWorkStatus) {
      this.inspectService.changeWorkStatus(this.inspectDescriptionWorkAndBuhinData);
    }
    this.tmpDeleteWorkIndex = effectState.tmpDeleteWorkIndex;
    this.$set(this, "listManualBuhinFiltered", effectState.listManualBuhinFiltered);
    this.$set(this, "listSelectedBuhin", effectState.listSelectedBuhin);
    if (effectState.shouldMapBuhin) {
      this.mapBuhin();
    }
    if (effectState.shouldEmitCallbackDeleteBuhin) {
      if (effectState.shouldUpdateWorkBuhinSelected) {
        this.workAndBuhinDataService.setWorkBuhinSelected(effectState.workBuhinSelected);
      }
      this.isChange = effectState.isChange;
      this.isSocket = effectState.isSocket;
      this.$emit(
        effectState.callbackDeleteBuhinEventName,
        effectState.callbackDeleteBuhinPayload
      );
    }
  }

  /*
   * applyManualBuhinDeleteAfterCommitEffectState を onConfirmDelete() から分離し、
   * 手入力部品/純正部品削除後の state 反映、作業再判定、callback emit の適用順を一箇所に寄せるため。
   */
  applyManualBuhinDeleteAfterCommitEffectState(
    effectState: WorkBuhinDelete.ManualBuhinDeleteAfterCommitApplyEffectState
  ) {
    this.tmpDeletedBuhin = effectState.tmpDeletedBuhin;
    this.isChange = effectState.isChange;
    if (effectState.shouldApplyManualBuhinListToWork) {
      effectState.targetWork.manualBuhinList = effectState.manualBuhinList;
    }
    if (effectState.shouldCheckWorkBuhinSelected) {
      this.checkWorkBuhinSelected(effectState.workBuhinSelectedCheckTarget);
    }
    if (effectState.shouldCheckDisabledBtnConfirm) {
      this.checkDisabledBtnConfirm(effectState.disabledBtnConfirmCheckTarget);
    }
    if (effectState.shouldEmitCallbackDeleteBuhin) {
      this.$emit(
        effectState.callbackDeleteBuhinEventName,
        {
          ...effectState.callbackDeleteBuhinPayload,
          work: effectState.targetWork
        }
      );
    }
  }

  /**
   * 用途: 現在対象の作業を取得し active index を同期する。
   * WHY: list 差異と component state 更新を同じ入口で扱うため。
   */
  getWork(data: any = null) {
    const sourceData = data == null ? undefined : data;
    const context = this.refreshWorkBuhinContext(sourceData);
    const effectState = this.workAndBuhinDataService.buildCurrentWorkEffectState({
      data: sourceData,
      context,
      activeWorkIndex: this.activeWorkIndex,
      isManualWork: this.isManualWork,
      editSeibi: this.editSeibi,
      activeSeibiNm: this.activeSeibiNm
    });
    if (effectState.shouldUpdateActiveWorkIndex) {
      this.activeWorkIndex = effectState.activeWorkIndex;
    }
    return effectState.work;
  }

  /**
   * 用途: isBuhinNotChange で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  isBuhinNotChange() {
    return WorkBuhinChange.buildBuhinNotChangeState(this.getWork(), this.listSelectedBuhin, {
      isDialog: this.isDialog,
      tmpDeletedManualBuhinList: this.tmpDeletedManualBuhinList
    }).isBuhinNotChange;
  }

  /**
   * 用途: onCloseBuhinDialog で UI event や親 event を受けて処理を開始する。
   * WHY: 画面操作の入口と helper/service 呼び出しを明確に分けるため。
   */
  onCloseBuhinDialog() {
    const closeActionState = WorkBuhinChange.buildCloseBuhinDialogState({
      activeWorkIndex: this.activeWorkIndex,
      sknInspectType: this.workAndBuhinDataService.getSknInspectType(),
      isBuhinNotChange: this.isBuhinNotChange(),
      hasPendingBuhinEdit: this.hasPendingBuhinEdit,
      isKouchinChange: this.isKouchinChange
    });
    const closeEffectState = WorkBuhinChange.buildCloseBuhinDialogApplyEffectState(closeActionState);
    if (closeEffectState.shouldSetShowConfirmDialog2) {
      this.showConfirmDialog2 = closeEffectState.showConfirmDialog2;
    }
    if (closeEffectState.shouldClose) {
      this.onClose();
    }
  }

  /**
   * 用途: isSelected で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  isSelected(buhin: BuhinDetail) {
    return WorkBuhinMatch.buildBuhinSelectedState(
      this.listSelectedBuhin,
      buhin
    ).isSelected;
  }

  /**
   * 用途: 親 ref から部品選択 UI を閉じる。
   * WHY: 親側互換 API の表示副作用を component 側で維持するため。
   */
  hideBuhin() {
    const hideState = WorkBuhinPublicApi.buildHideBuhinPublicState();
    this.$set(this, "showBuhin", hideState.showBuhin);
  }

  /**
   * 用途: onClickManualBuhin で UI event や親 event を受けて処理を開始する。
   * WHY: 画面操作の入口と helper/service 呼び出しを明確に分けるため。
   */
  onClickManualBuhin(buhin: BuhinDetail) {
    const clickActionState = WorkBuhinQuantity.buildManualBuhinClickActionState({
      disabledBtnNoBuhin: this.disabledBtnNoBuhin,
      buhinCd: buhin.buhinCd
    });
    const clickEffectState = WorkBuhinQuantity.buildManualBuhinClickApplyEffectState(clickActionState);
    if (clickEffectState.shouldToggleQuantity) {
      WorkBuhinQuantity.toggleManualBuhinQuantity(buhin);
    }
    if (clickEffectState.shouldSyncJunseiBuhinSelection) {
      WorkBuhinQuantity.syncJunseiBuhinSelection(this.listSelectedBuhin, buhin);
    }
    if (clickEffectState.shouldCheckDisabledBtnConfirm) {
      this.checkDisabledBtnConfirm();
    }
  }

  /**
   * 用途: get katashikiShiteiNo で WorkAndBuhin の画面状態を処理する。
   * WHY: 既存 template/ref 互換を維持しながら責務境界を明示するため。
   */
  get katashikiShiteiNo() {
    return WorkBuhinVehicleDisplay.buildVehicleDisplayState({
      carSelection: this.carSelection,
      currentState: this.currentState
    }).katashikiShiteiNo;
  }

  /**
   * 用途: get ruibetsuKubunNo で WorkAndBuhin の画面状態を処理する。
   * WHY: 既存 template/ref 互換を維持しながら責務境界を明示するため。
   */
  get ruibetsuKubunNo() {
    return WorkBuhinVehicleDisplay.buildVehicleDisplayState({
      carSelection: this.carSelection,
      currentState: this.currentState
    }).ruibetsuKubunNo;
  }

  /**
   * 用途: get fTireSizeInput で WorkAndBuhin の画面状態を処理する。
   * WHY: 既存 template/ref 互換を維持しながら責務境界を明示するため。
   */
  get fTireSizeInput() {
    return WorkBuhinVehicleDisplay.buildVehicleDisplayState({
      carSelection: this.carSelection,
      currentState: this.currentState
    }).fTireSizeInput;
  }
  /**
   * 用途: get rTireSizeInput で WorkAndBuhin の画面状態を処理する。
   * WHY: 既存 template/ref 互換を維持しながら責務境界を明示するため。
   */
  get rTireSizeInput() {
    return WorkBuhinVehicleDisplay.buildVehicleDisplayState({
      carSelection: this.carSelection,
      currentState: this.currentState
    }).rTireSizeInput;
  }

  /**
   * 用途: get isUseJunseiBuhin で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  get isUseJunseiBuhin() {
    return WorkBuhinVehicleDisplay.buildWorkBuhinAvailabilityState({
      hideNisseirenJunsei: this.hideNisseirenJunsei,
      isUseNisseiren: this.isUseNisseiren
    }).isUseJunseiBuhin;
  }

  /**
   * 用途: 型式表示用 state をまとめて反映する。
   * WHY: 複数の表示項目を同じ helper 結果から更新するため。
   */
  applyKatashikiDisplayUpdateState() {
    const displayState = WorkBuhinNisseiren.buildKatashikiDisplayUpdateState({
      hasKatashiki: this.hasKatashiki,
      katashikiParams: this.katashikiService.getKatashikiParams(),
      fallbackKatashiki: this.katashiki,
      fallbackEngineKatashiki: this.engineKatashiki,
      currentState: this.currentState
    });
    this.$set(this, "showKatashiki", displayState.showKatashiki);
    this.$set(this, "showEngineKatashiki", displayState.showEngineKatashiki);
    this.$set(this, "showKakyuki", displayState.showKakyuki);
    this.$set(this, "showModelNm", displayState.showModelNm);
  }

  /**
   * 用途: updateShowKatashiki で表示用の派生 state を更新する。
   * WHY: 複数表示項目を同じ apply 処理に集約するため。
   */
  updateShowKatashiki() {
    this.applyKatashikiDisplayUpdateState();
  }

  /**
   * 用途: updateShowEngineKatashiki で表示用の派生 state を更新する。
   * WHY: 複数表示項目を同じ apply 処理に集約するため。
   */
  updateShowEngineKatashiki() {
    this.applyKatashikiDisplayUpdateState();
  }

  /**
   * 用途: updateShowKakyuki で表示用の派生 state を更新する。
   * WHY: 複数表示項目を同じ apply 処理に集約するため。
   */
  updateShowKakyuki() {
    this.applyKatashikiDisplayUpdateState();
  }

  /**
   * 用途: updateShowModelNm で表示用の派生 state を更新する。
   * WHY: 複数表示項目を同じ apply 処理に集約するため。
   */
  updateShowModelNm() {
    this.applyKatashikiDisplayUpdateState();
  }

  /**
   * 用途: 既存 template / method 互換用の facade。工賃入力の readonly は isWorkKouchinReadonly() で扱う。
   * WHY: 既存の関数説明を block comment 形式に揃えるため。
   */
  isNisseirenReadOnly(work: any) {
    return WorkBuhinNisseiren.isNisseirenWorkReadOnly(work);
  }

  /**
   * 用途: isWorkKouchinReadonly で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  isWorkKouchinReadonly(work: any) {
    return WorkBuhinNisseiren.buildNisseirenWorkReadonlyState({
      disabledBtnNoBuhin: this.disabledBtnNoBuhin,
      work
    }).isReadonly;
  }

  /**
   * 用途: getWorkKouchinDisabledValue で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getWorkKouchinDisabledValue(work: any, allowNotFreeKouchin: boolean) {
    return WorkBuhinNisseiren.buildWorkKouchinDisabledState({
      work,
      allowNotFreeKouchin
    }).disabledValue;
  }

  /**
   * 用途: isBuhinInputReadonly で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  isBuhinInputReadonly() {
    return WorkBuhinQuantity.buildBuhinInputReadonlyState({
      disabledBtnNoBuhin: this.disabledBtnNoBuhin
    }).isReadonly;
  }

  /**
   * 用途: isBuhinQuantityReadonly で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  isBuhinQuantityReadonly(buhin: BuhinDetail) {
    return WorkBuhinQuantity.buildBuhinQuantityControlState({
      disabledBtnNoBuhin: this.disabledBtnNoBuhin,
      quantity: buhin.quantity
    }).isReadonly;
  }

  /**
   * 用途: isBuhinQuantityMinusDisabled で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  isBuhinQuantityMinusDisabled(buhin: BuhinDetail) {
    return WorkBuhinQuantity.buildBuhinQuantityControlState({
      disabledBtnNoBuhin: this.disabledBtnNoBuhin,
      quantity: buhin.quantity
    }).isMinusDisabled;
  }

  /**
   * 用途: isBuhinQuantityPlusDisabled で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  isBuhinQuantityPlusDisabled(buhin: BuhinDetail) {
    return WorkBuhinQuantity.buildBuhinQuantityControlState({
      disabledBtnNoBuhin: this.disabledBtnNoBuhin,
      quantity: buhin.quantity
    }).isPlusDisabled;
  }

  /**
   * 用途: isNoBuhinConfirmDisabled で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  isNoBuhinConfirmDisabled() {
    return this.isBuhinConfirmBusy() || WorkBuhinButton.buildNoBuhinConfirmButtonState({
      disabledBtnNoBuhin: this.disabledBtnNoBuhin,
      activeWorkIndex: this.activeWorkIndex
    }).isDisabled;
  }

  /**
   * 用途: isBuhinConfirmDisabled で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  isBuhinConfirmDisabled() {
    return this.isBuhinConfirmBusy() || WorkBuhinButton.buildBuhinConfirmButtonState({
      disabledBtnConfirm: this.disabledBtnConfirm,
      activeWorkIndex: this.activeWorkIndex
    }).isDisabled;
  }

  /**
   * 用途: showNisseirenWorkSearchButton で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showNisseirenWorkSearchButton() {
    return WorkBuhinNisseiren.buildNisseirenWorkSearchButtonState({
      isUseNisseiren: this.isUseNisseiren,
      hideNisseirenJunsei: this.hideNisseirenJunsei,
      hasKatashiki: this.hasKatashiki,
      isDiscount: this.isDiscount
    }).shouldShow;
  }

  /**
   * 用途: isNisseirenWorkSearchDisabled で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  isNisseirenWorkSearchDisabled() {
    return WorkBuhinNisseiren.buildNisseirenWorkSearchButtonState({
      isUseNisseiren: this.isUseNisseiren,
      hideNisseirenJunsei: this.hideNisseirenJunsei,
      hasKatashiki: this.hasKatashiki,
      isDiscount: this.isDiscount
    }).isDisabled;
  }

  /**
   * 用途: isJunseiBuhinSearchDisabled で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  isJunseiBuhinSearchDisabled() {
    return this.isNoBuhinConfirmDisabled() || WorkBuhinNisseiren.buildJunseiBuhinSearchButtonState({
      hasKatashiki: this.hasKatashiki
    }).isDisabled;
  }

  /**
   * 用途: showKatashikiButton で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showKatashikiButton() {
    return WorkBuhinNisseiren.buildKatashikiButtonDisplayState({
      isUseNisseiren: this.isUseNisseiren
    }).shouldShow;
  }

  /**
   * 用途: isJunseiBuhin で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  isJunseiBuhin(buhinCd: any) {
    return WorkBuhinMatch.buildJunseiBuhinDisplayState(buhinCd).isJunseiBuhin;
  }

  /**
   * 用途: showManualBuhinHeader で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showManualBuhinHeader() {
    return WorkBuhinDisplay.buildManualBuhinHeaderDisplayState(
      this.listManualBuhinFiltered
    ).shouldShowManualBuhinHeader;
  }

  /**
   * 用途: template 全体の表示 state を取得する。
   * WHY: 表示条件を helper に寄せ template の条件分岐を薄くするため。
   */
  getTemplateDisplayState() {
    return WorkBuhinDisplay.buildWorkBuhinTemplateDisplayState({
      showTitle: this.showTitle,
      editSeibi: this.editSeibi,
      isBuhinError: this.isBuhinError,
      showBuhin: this.showBuhin,
      closeBtn: this.closeBtn
    });
  }

  /**
   * 用途: showWorkTitle で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showWorkTitle() {
    return this.getTemplateDisplayState().shouldShowTitle;
  }

  /**
   * 用途: showManualWorkAdd で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showManualWorkAdd() {
    return this.getTemplateDisplayState().shouldShowManualWorkAdd;
  }

  /**
   * 用途: showBuhinErrorMessage で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showBuhinErrorMessage() {
    return this.getTemplateDisplayState().shouldShowBuhinError;
  }

  /**
   * 用途: showBuhinContent で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showBuhinContent() {
    return this.getTemplateDisplayState().shouldShowBuhin;
  }

  /**
   * 用途: showCloseButton で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showCloseButton() {
    return this.getTemplateDisplayState().shouldShowCloseButton;
  }

  /**
   * 用途: getLabelClass で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getLabelClass(baseClass: string) {
    return WorkBuhinDisplay.buildWorkBuhinLabelClassState({
      isDialog: this.isDialog,
      baseClass
    }).labelClass;
  }

  /**
   * 用途: getDiscountLabelClass で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getDiscountLabelClass() {
    return this.getLabelClass("discount-label");
  }

  /**
   * 用途: getExtremeLabelClass で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getExtremeLabelClass() {
    return this.getLabelClass("ext-label");
  }

  /**
   * 用途: getNisseirenLabelClass で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getNisseirenLabelClass() {
    return this.getLabelClass("nisseiren-label");
  }

  /**
   * 用途: getJunseiLabelClass で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getJunseiLabelClass() {
    return this.getLabelClass("junsei-label");
  }

  /**
   * 用途: getWorkBuhinContainerDisplayState で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getWorkBuhinContainerDisplayState() {
    return WorkBuhinDisplay.buildWorkBuhinContainerDisplayState({
      isDialog: this.isDialog
    });
  }

  /**
   * 用途: getWorkContainerClass で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getWorkContainerClass() {
    return this.getWorkBuhinContainerDisplayState().workContainerClass;
  }

  /**
   * 用途: getBuhinContainerClass で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getBuhinContainerClass() {
    return this.getWorkBuhinContainerDisplayState().buhinContainerClass;
  }

  /**
   * 用途: showFooterButtons で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showFooterButtons() {
    return this.getWorkBuhinContainerDisplayState().shouldShowFooterButtons;
  }

  /**
   * 用途: showDialogButtons で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showDialogButtons() {
    return this.getWorkBuhinContainerDisplayState().shouldShowDialogButtons;
  }

  /**
   * 用途: getRecommendWorkRowDisplayState で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getRecommendWorkRowDisplayState() {
    return this.workAndBuhinDataService.buildRecommendWorkRowDisplayState();
  }

  /**
   * 用途: showRecommendWorkRow で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showRecommendWorkRow() {
    return this.getRecommendWorkRowDisplayState().shouldShowRow;
  }

  /**
   * 用途: getRecommendWorkIconClass で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getRecommendWorkIconClass() {
    return this.getRecommendWorkRowDisplayState().iconClasses;
  }

  /**
   * 用途: getNormalBuhinRowDisplayState で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getNormalBuhinRowDisplayState(buhin: BuhinDetail) {
    return WorkBuhinDisplay.buildNormalBuhinRowDisplayState({
      buhin,
      isSelected: this.isSelected(buhin),
      isConfirmed: this.isBuhinConfirm(buhin),
      shouldDisplayDiscountPrice: this.isDispDiscount(buhin)
    });
  }

  /**
   * 用途: isNormalBuhinChecked で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  isNormalBuhinChecked(buhin: BuhinDetail) {
    return this.getNormalBuhinRowDisplayState(buhin).isChecked;
  }

  /**
   * 用途: getNormalBuhinLabelClass で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getNormalBuhinLabelClass(buhin: BuhinDetail) {
    return this.getNormalBuhinRowDisplayState(buhin).labelClasses;
  }

  /**
   * 用途: showNormalBuhinExtremeLabel で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showNormalBuhinExtremeLabel(buhin: BuhinDetail) {
    return this.getNormalBuhinRowDisplayState(buhin).shouldShowExtremeLabel;
  }

  /**
   * 用途: showNormalBuhinConfirmStatus で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showNormalBuhinConfirmStatus(buhin: BuhinDetail) {
    return this.getNormalBuhinRowDisplayState(buhin).shouldShowConfirmStatus;
  }

  /**
   * 用途: showNormalBuhinDiscountPrice で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showNormalBuhinDiscountPrice(buhin: BuhinDetail) {
    return this.getNormalBuhinRowDisplayState(buhin).shouldShowDiscountPrice;
  }

  /**
   * 用途: getBuhinFilterClass で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getBuhinFilterClass(buhinBunruiCd: string) {
    return {
      active: this.filterActive(buhinBunruiCd)
    };
  }

  /**
   * 用途: showBuhinTopic で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showBuhinTopic(target: any, index: number) {
    return this.chkRedundancyTopic(target, index);
  }

  /**
   * 用途: getBuhinTabDisplayState で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getBuhinTabDisplayState() {
    return WorkBuhinTab.buildBuhinTabDisplayState({
      isUseJunseiBuhin: this.isUseJunseiBuhin,
      osusumeBuhinList: this.osusumeBuhinList,
      activeBuhinCateIndex: this.activeBuhinCateIndex,
      isNextageCustom: this.isNextageCustom
    });
  }

  /**
   * 用途: showJunseiBuhinTab で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showJunseiBuhinTab() {
    return this.getBuhinTabDisplayState().shouldShowJunseiTab;
  }

  /**
   * 用途: showOsusumeBuhinTab で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showOsusumeBuhinTab() {
    return this.getBuhinTabDisplayState().shouldShowOsusumeTab;
  }

  /**
   * 用途: showJunseiBuhinSearchButton で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showJunseiBuhinSearchButton() {
    return this.getBuhinTabDisplayState().shouldShowJunseiSearchButton;
  }

  /**
   * 用途: showSelectAllOsusumeBuhin で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showSelectAllOsusumeBuhin() {
    return this.getBuhinTabDisplayState().shouldShowSelectAllOsusume;
  }

  /**
   * 用途: extremeBuhinTabLabel で WorkAndBuhin の画面状態を処理する。
   * WHY: 既存 template/ref 互換を維持しながら責務境界を明示するため。
   */
  extremeBuhinTabLabel() {
    return this.getBuhinTabDisplayState().extremeTabLabel;
  }

  /**
   * 用途: getBuhinTabClass で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getBuhinTabClass(targetIndex: number) {
    return WorkBuhinTab.buildBuhinTabClassState({
      activeBuhinCateIndex: this.activeBuhinCateIndex,
      targetIndex
    }).classes;
  }

  /**
   * 用途: showManualBuhinList で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showManualBuhinList() {
    return WorkBuhinDisplay.buildManualBuhinListDisplayState(
      this.listManualBuhinFiltered
    ).shouldShowList;
  }

  /**
   * 用途: getManualBuhinRowClass で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getManualBuhinRowClass(buhin: BuhinDetail) {
    return WorkBuhinDisplay.buildManualBuhinRowDisplayState(buhin).classes;
  }

  /**
   * 用途: getManualBuhinIconClass で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getManualBuhinIconClass(buhin: BuhinDetail) {
    return WorkBuhinDisplay.buildManualBuhinRowDisplayState(buhin).iconClasses;
  }

  /**
   * 用途: showManualBuhinNameText で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showManualBuhinNameText(buhin: BuhinDetail) {
    return WorkBuhinDisplay.buildManualBuhinRowDisplayState(buhin).shouldShowNameText;
  }

  /**
   * 用途: showManualBuhinJunseiLabel で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showManualBuhinJunseiLabel(buhin: BuhinDetail) {
    return WorkBuhinDisplay.buildManualBuhinRowDisplayState(buhin).shouldShowJunseiLabel;
  }

  /**
   * 用途: showManualBuhinEditButton で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showManualBuhinEditButton(buhin: BuhinDetail) {
    return WorkBuhinDisplay.buildManualBuhinRowDisplayState(buhin).shouldShowEditButton;
  }

  /**
   * 用途: isManualBuhinEditButtonDisabled で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  isManualBuhinEditButtonDisabled(buhin: BuhinDetail) {
    return WorkBuhinDisplay.buildManualBuhinRowDisplayState(buhin).isEditButtonDisabled;
  }

  /**
   * 用途: getManualBuhinEditButtonLabel で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getManualBuhinEditButtonLabel(buhin: BuhinDetail) {
    return WorkBuhinDisplay.buildManualBuhinRowDisplayState(buhin).editButtonLabel;
  }

  /**
   * 用途: showManualBuhinConfirmStatus で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showManualBuhinConfirmStatus(buhin: BuhinDetail) {
    return WorkBuhinDisplay.buildManualBuhinRowDisplayState(buhin).shouldShowConfirmedStatus;
  }

  /**
   * 用途: showManualBuhinDiscountPrice で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showManualBuhinDiscountPrice(buhin: BuhinDetail) {
    return WorkBuhinDisplay.buildManualBuhinRowDisplayState({
      ...(buhin as any),
      shouldDisplayDiscountPrice: this.isDispDiscount(buhin)
    } as any).shouldShowDiscountPrice;
  }

  /**
   * 用途: getExtendsImageButtonState で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getExtendsImageButtonState() {
    return WorkBuhinDisplay.buildExtendsImageButtonState({
      inspectResult: this.workAndBuhinDataService.getInspectResult(),
      isCanExtendsImage: this.isCanExtendsImage,
      extendsImageInspect: this.extendsImageInspect
    });
  }

  /**
   * 用途: showExtendsImageButton で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showExtendsImageButton() {
    return this.getExtendsImageButtonState().shouldShow;
  }

  /**
   * 用途: isExtendsImageButtonDisabled で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  isExtendsImageButtonDisabled() {
    return this.getExtendsImageButtonState().isDisabled;
  }

  /**
   * 用途: extendsImageButtonClass で WorkAndBuhin の画面状態を処理する。
   * WHY: 既存 template/ref 互換を維持しながら責務境界を明示するため。
   */
  extendsImageButtonClass() {
    return this.getExtendsImageButtonState().buttonClass;
  }

  /**
   * 用途: extendsImageButtonLabel で WorkAndBuhin の画面状態を処理する。
   * WHY: 既存 template/ref 互換を維持しながら責務境界を明示するため。
   */
  extendsImageButtonLabel() {
    return this.getExtendsImageButtonState().label;
  }

  /**
   * 用途: getNormalWorkRowClass で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getNormalWorkRowClass(work: any, index: number) {
    return WorkBuhinDisplay.buildNormalWorkRowClassState({
      work,
      index,
      activeWorkIndex: this.activeWorkIndex,
      isManualWork: this.isManualWork
    }).classes;
  }

  /**
   * 用途: getManualWorkRowClass で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getManualWorkRowClass(work: any, index: number) {
    return WorkBuhinDisplay.buildManualWorkRowClassState({
      work,
      index,
      activeWorkIndex: this.activeWorkIndex,
      isManualWork: this.isManualWork
    }).classes;
  }

  /**
   * 用途: showEditResultLink で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showEditResultLink(work: any) {
    return WorkBuhinDisplay.buildWorkRowActionDisplayState({
      editResult: this.editResult,
      work
    }).shouldShowEditResultLink;
  }

  /**
   * 用途: showResetWorkLink で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showResetWorkLink(work: any) {
    return WorkBuhinDisplay.buildWorkRowActionDisplayState({
      editResult: this.editResult,
      work
    }).shouldShowResetWorkLink;
  }

  /**
   * 用途: showDiscountWorkLabel で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showDiscountWorkLabel(work: any) {
    return WorkBuhinDisplay.buildWorkRowLabelDisplayState(work).shouldShowDiscountLabel;
  }

  /**
   * 用途: showExtremeWorkLabel で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showExtremeWorkLabel(work: any) {
    return WorkBuhinDisplay.buildWorkRowLabelDisplayState(work).shouldShowExtremeLabel;
  }

  /**
   * 用途: showNisseirenWorkLabel で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showNisseirenWorkLabel(work: any) {
    return WorkBuhinDisplay.buildWorkRowLabelDisplayState(work).shouldShowNisseirenLabel;
  }

  /**
   * 用途: showManualWorkEditButton で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showManualWorkEditButton(work: any) {
    return WorkBuhinDisplay.buildWorkRowLabelDisplayState(work).shouldShowManualWorkEditButton;
  }

  /**
   * 用途: showManualWorkNameText で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showManualWorkNameText(work: any) {
    return WorkBuhinDisplay.buildWorkRowLabelDisplayState(work).shouldShowManualWorkNameText;
  }

  /**
   * 用途: showManualWorkEditInput で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showManualWorkEditInput(work: any) {
    return WorkBuhinDisplay.buildWorkRowLabelDisplayState(work).shouldShowManualWorkEditInput;
  }

  /**
   * 用途: getManualWorkEditButtonLabel で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getManualWorkEditButtonLabel(work: any) {
    return WorkBuhinDisplay.buildWorkRowLabelDisplayState(work).manualWorkEditButtonLabel;
  }

  /**
   * 用途: getManualWorkNameSpan で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getManualWorkNameSpan(work: any) {
    return WorkBuhinDisplay.buildWorkRowLabelDisplayState(work).manualWorkNameSpan;
  }

  /**
   * 用途: getNisseirenLabelSpan で template や後続処理に渡す値を取得する。
   * WHY: data/service の参照方法を一箇所に寄せるため。
   */
  getNisseirenLabelSpan(work: any) {
    return WorkBuhinDisplay.buildWorkRowLabelDisplayState(work).nisseirenLabelSpan;
  }

  /**
   * 用途: initSeibiDisableSave で初期選択や初期表示 state を整える。
   * WHY: created 後の復元/初期化手順を明示するため。
   */
  initSeibiDisableSave(seibiList: any) {
    const updates = this.workAndBuhinDataService.buildSeibiDisableSaveUpdates({
      seibiList,
      isSeibiDetailIdExist: this.isSeibiDetailIdExist
    });
    const effectState = WorkBuhinInit.buildSeibiDisableSaveApplyEffectState(updates);
    if (effectState.shouldApply) {
      effectState.updates.forEach((update: any) => {
        update.seibi.disabledSave = update.disabledSave;
      });
    }
  }

  /**
   * 用途: onClickInputBuhinNm で UI event や親 event を受けて処理を開始する。
   * WHY: 画面操作の入口と helper/service 呼び出しを明確に分けるため。
   */
  onClickInputBuhinNm(e: any) {
    const inputClickActionState = WorkBuhinEdit.buildBuhinNameInputClickActionState();
    if (inputClickActionState.shouldStopPropagation) {
      e.stopPropagation();
    }
  }

  /**
   * 用途: 推奨バッテリーからのバッテリー規格初期選択を再実行できる状態に戻す。
   * WHY: 親データの差し替え後に、古い自動変換済みフラグで候補絞り込みがスキップされるのを防ぐため。
   */
  resetBatteryInitialDisplayState() {
    this.batteryConvertFlg = false;
  }

  /**
   * 用途: 推奨バッテリーの標準/寒冷地表示と警告表示 state を組み立てる。
   * WHY: 部品一覧のバッテリーカテゴリで、適合表の不足や複数指定を作業者に見せるため。
   */
  get makeAreaBatteryKwds() {
    let coldAreaBatteryKwds: string = "";
    let baseAreaBatteryKwds: string = "";
    let coldAreaBatteryKwdsCount: number = 0;
    let baseAreaBatteryKwdsCount: number = 0;
    if ( this.carSelection && this.carSelection.batteryKwds && this.carSelection.batteryKwds.length > 0 ) {
      this.batteryWarnNonBase = false;
      this.batteryWarnNonCold = false;
      this.batteryWarnDoubleSet = false;
      this.carSelection.batteryKwds.forEach((elm: any) => {

        // バッテリーを複数個指定するキーワードだった場合
        const cut = elm.keyword.indexOf("×");
        if (cut !== -1) { this.batteryWarnDoubleSet = true; }

        // 標準、寒冷地分岐
        if ( elm.isColdArea == 1 ) {
          coldAreaBatteryKwdsCount++;
          coldAreaBatteryKwds = elm.keyword;
        } else {
          baseAreaBatteryKwdsCount++;
          baseAreaBatteryKwds = elm.keyword;
        }
      });

      if ( baseAreaBatteryKwds == "" && baseAreaBatteryKwds == "" ) {
        // どちらも「お問い合わせください」
        this.batteryWarnNonKey = true;
        return "【現車を確認してください】";
      } else if ( baseAreaBatteryKwdsCount <= 1 && coldAreaBatteryKwdsCount <= 1 ) {
        const baseAreaMsg = baseAreaBatteryKwds != "" ? baseAreaBatteryKwds : "要現車確認";
        const coldAreaMsg = coldAreaBatteryKwds != "" ? coldAreaBatteryKwds : "要現車確認";
        this.batteryWarnNonBase = baseAreaBatteryKwds == "";
        this.batteryWarnNonCold = coldAreaBatteryKwds == "";
        this.batteryWarnNonKey = false;
        return "【標準：" + baseAreaMsg + "&nbsp;&nbsp;寒冷地：" + coldAreaMsg + "】";
      } else {
        // 標準が複数指定 or 寒冷地が複数指定
        this.batteryWarnNonKey = false;
        return "【現車を確認してください】";
      }
    }
    this.batteryWarnNonKey = true;
    return "【現車を確認してください】";
  }

  /**
   * 用途: バッテリー型番検索入力時に規格ボタンの選択を解除する。
   * WHY: 任意キーワード検索と規格ボタン検索の条件が同時適用されないようにするため。
   */
  chkBatteryFreeKwd(key: string) {
    if (key != "") {
      this.clearBatteryKeywordButtons();
    }
  }

  /**
   * 用途: バッテリー規格ボタンの選択状態を切り替えて一覧を再絞り込みする。
   * WHY: UI 上の規格選択を部品候補表示へ即時反映するため。
   */
  onBatteryFilter(item: any) {
    this.batteryFreeKwd = "";
    item.value = item.value == 1 ? 0 : 1;
    this.setFilter();
  }

  /**
   * 用途: バッテリー検索条件を推奨バッテリー由来の初期状態に戻す。
   * WHY: 手動検索後でも標準の適合候補へ戻せる導線を維持するため。
   */
  formatBatterry() {
    this.batteryFreeKwd = "";
    this.convertBattery();
    this.setFilter();
  }

  /**
   * 用途: バッテリー規格ボタンの選択状態をすべて解除する。
   * WHY: 型番検索や初期化時に前回の規格条件が残らないようにするため。
   */
  clearBatteryKeywordButtons() {
    this.batteryKeywordsBtn.forEach((group: any) => {
      group.tips.forEach((tip: any) => {
        tip.value = 0;
      });
    });
  }

  /**
   * 用途: 指定した規格グループ内のバッテリータグを選択状態にする。
   * WHY: 推奨バッテリー文字列を UI の規格ボタン選択へ変換するため。
   */
  selectBatteryKeywordButton(type: number, tag: string) {
    this.batteryKeywordsBtn
      .filter((group: any) => group.type == type)
      .forEach((group: any) => {
        group.tips.forEach((tip: any) => {
          if (tip.tag == tag) {
            tip.value = 1;
          }
        });
      });
  }

  /**
   * 用途: 推奨バッテリー文字列から規格ボタンの初期選択を作る。
   * WHY: 適合表の型番情報を部品候補の絞り込み条件として再利用するため。
   */
  convertBattery() {
    this.clearBatteryKeywordButtons();
    const keys: string[] = [];
    if ( this.carSelection && this.carSelection.batteryKwds && this.carSelection.batteryKwds.length > 0 ) {
      // 推奨バッテリー 情報分解
      this.carSelection.batteryKwds.forEach((elm: any) => {
        let kw = (elm.keyword || "").trim();

        // 「×」以降を削除
        const cut = kw.indexOf("×");
        if (cut !== -1) { kw = kw.slice(0, cut); }

        // 「+」で分岐（分割）して追加
        if (kw.includes("+")) {
          kw.split("+")
            .map((p: string) => p.trim())
            .filter(Boolean)
            .forEach((p: string) => keys.push(p));
        } else if (kw) {
          keys.push(kw);
        }
      });

      // 分解したキーワード から バッテリー規格選択
      const terminals: string[] = [];
      keys.forEach((key: string) => {
        const kw = key.trim();
        if (/^LN[0-6]$/.test(kw)) {
          this.selectBatteryKeywordButton(2, "LNシリーズ");
          return;
        }

        const terminal = kw.match(/(L|R)$/);
        if (terminal) {
          const batteryType = kw.slice(0, -1);
          this.selectBatteryKeywordButton(1, batteryType);
          terminals.push(terminal[1]);
        } else {
          this.selectBatteryKeywordButton(1, kw);
        }
      });
      if (terminals.indexOf("L") > -1) {
        this.selectBatteryKeywordButton(0, "L");
      }
      if (terminals.indexOf("R") > -1) {
        this.selectBatteryKeywordButton(0, "R");
      }
    }
  }

  /**
   * 用途: 正規表現に使う任意文字列をエスケープする。
   * WHY: バッテリー型番やタグ文字列を安全に部分一致条件へ変換するため。
   */
  escapeRegExp(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  /**
   * 用途: バッテリー端子位置タグの正規表現パターンを作る。
   * WHY: L/R の選択有無に応じて型番末尾条件を切り替えるため。
   */
  createBatteryTerminalPattern(tags: string[], defaultPattern: string = ""): string {
    if (tags.length == 1) {
      return this.escapeRegExp(tags[0]);
    }
    if (tags.length > 1) {
      return "(" + tags.map((tag: string) => this.escapeRegExp(tag)).join("|") + ")";
    }
    return defaultPattern;
  }

  /**
   * 用途: バッテリーカテゴリの部品候補を検索条件で絞り込む。
   * WHY: 推奨バッテリーや手動型番検索に合う候補を優先表示しつつ、選択済み部品は表示から落とさないため。
   */
  filterButteryBuhin(buhinContent: SubBuhinCategory[]) {
    buhinContent = buhinContent.map((element: any) => {
      let items = element.items;
      // バッテリーのデータだけを対象に取る
      if ( this.isNextageCustom && element.buhinBunruiId == "7" ) {

        // 初回時 推奨バッテリー から バッテリー規格選択 を行う
        if ( !this.batteryConvertFlg ) {
          this.convertBattery();
        }

        // 正規表現による絞り込み条件を生成
        const patterns: RegExp[] = [];

        if ( this.batteryFreeKwd != "" ) {
          // バッテリー型番検索 の任意検索は部分一致
          patterns.push(new RegExp(this.escapeRegExp(this.batteryFreeKwd)));
        } else {
          // バッテリー規格選択 から生成
          const selectedGroups = this.batteryKeywordsBtn
            .map((group: any) => ({
              type: group.type,
              tips: group.tips.filter((tip: any) => tip.value == 1)
            }))
            .filter((group: any) => group.tips.length > 0);
          const hasType1 = selectedGroups.some((group: any) => group.type == 1);
          const hasType2 = selectedGroups.some((group: any) => group.type == 2);

          if (hasType1) {
            // 通常パターン
            const type1Tags: string[] = [];
            selectedGroups
              .filter((group: any) => group.type == 1)
              .forEach((group: any) => {
                group.tips.forEach((tip: any) => type1Tags.push(tip.tag));
              });
            const type0Tags: string[] = [];
            selectedGroups
              .filter((group: any) => group.type == 0)
              .forEach((group: any) => {
                group.tips.forEach((tip: any) => type0Tags.push(tip.tag));
              });
            const terminalPattern = this.createBatteryTerminalPattern(type0Tags, "L|R");
            patterns.push(new RegExp(
              "(" + type1Tags.map((tag: string) => this.escapeRegExp(tag)).join("|") + ")" +
              "(" + terminalPattern + ")$"
            ));
          }

          if (hasType2) {
            // LNシリーズ
            patterns.push(/LN[0-6][a-zA-Z]{0,3}$/);
          }

          if (!hasType1 && !hasType2) {
            // LRのみ
            const type0Tags: string[] = [];
            selectedGroups
              .filter((group: any) => group.type == 0)
              .forEach((group: any) => {
                group.tips.forEach((tip: any) => type0Tags.push(tip.tag));
              });
            const terminalPattern = this.createBatteryTerminalPattern(type0Tags);
            if (terminalPattern) {
              patterns.push(new RegExp(terminalPattern + "$"));
            }
          }
        }

        // 絞り込み条件が作られた場合は実際に絞り込む
        if (patterns.length > 0) {
          items = items.filter((elm: any) =>
            Number(elm.quantity) > 0 ||
            this.isBuhinConfirm(elm) ||
            patterns.some((pattern: RegExp) => pattern.test(elm.buhinNm || ""))
          );

          // 初回時 絞り込み成功した場合は選択領域を最小化する
          if (!this.batteryConvertFlg) {
            this.$nextTick(() => {
              if (
                this.batteryFreeKwd == "" &&
                items.length > 0 &&
                !this.batteryWarnNonKey &&
                !this.batteryWarnNonBase &&
                !this.batteryWarnNonCold
              ) {
                this.batteryCardOpened = false;
              }
            });
            this.batteryConvertFlg = true;
          }
        }
      }
      return { ...element, items };
    });

    return buhinContent;
  }

  /**
   * 用途: onSelectAllBuhin で UI event や親 event を受けて処理を開始する。
   * WHY: 画面操作の入口と helper/service 呼び出しを明確に分けるため。
   */
  onSelectAllBuhin() {
    const work = this.getWork();
    const selectAllState = this.workAndBuhinDataService.buildSelectAllBuhinState({
      work,
      buhinContent: this.buhinContent,
      osusumeBuhinList: this.osusumeBuhinList
    });
    const selectAllEffectState = WorkBuhinSelection.buildSelectAllBuhinApplyEffectState(selectAllState);
    if (selectAllEffectState.shouldApply) {
      this.$set(this, "buhinContent", selectAllEffectState.buhinContent);
      this.$set(this, "osusumeBuhinList", selectAllEffectState.osusumeBuhinList);
      this.$set(work, "osusumeBuhinList", selectAllEffectState.osusumeBuhinList);
      this.$set(this, "listSelectedBuhin", selectAllEffectState.selectedBuhinList);
    }
    if (selectAllEffectState.shouldCheckDisabledBtnConfirm) {
      this.checkDisabledBtnConfirm(work);
    }
  }

  /**
   * 用途: checkWorkBuhinSelected で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  checkWorkBuhinSelected(work: any) {
    const resetState = this.workAndBuhinDataService.buildWorkBuhinSelectedResetApplyState({
      work,
      manualBuhinLength: this.listManualBuhin.length,
      selectedBuhinLength: this.listSelectedBuhin.length
    });
    const effectState = WorkBuhinConfirm.buildWorkBuhinSelectedResetApplyEffectState(resetState);
    if (effectState.shouldResetWorkBuhinSelected) {
      work.buhinSelected = effectState.workBuhinSelected;
    }
    if (effectState.shouldResetDataWorkBuhinSelected) {
      this.workAndBuhinDataService.setWorkBuhinSelected(effectState.dataWorkBuhinSelected);
    }
  }

  /**
   * 用途: kouchinChange で WorkAndBuhin の画面状態を処理する。
   * WHY: 既存 template/ref 互換を維持しながら責務境界を明示するため。
   */
  kouchinChange() {
    const changeState = WorkBuhinChange.buildKouchinChangeState();
    this.isChange = changeState.isChange;
    this.isKouchinChange = changeState.isKouchinChange;
  }

  /**
   * 用途: initialSelectSeibi で初期選択や初期表示 state を整える。
   * WHY: created 後の復元/初期化手順を明示するため。
   */
  initialSelectSeibi() {
    const selectActionState = this.workAndBuhinDataService
      .buildInitialSelectSeibiActionState(this.isManualWork);
    if (selectActionState.shouldSelectWork) {
      this.onSelectWork(
        selectActionState.work,
        selectActionState.index,
        selectActionState.isManualWork
      );
    }
  }

  /**
   * 用途: get shadaiNo で WorkAndBuhin の画面状態を処理する。
   * WHY: 既存 template/ref 互換を維持しながら責務境界を明示するため。
   */
  get shadaiNo() {
    return WorkBuhinVehicleDisplay.buildVehicleDisplayState({
      carSelection: this.carSelection,
      currentState: this.currentState
    }).shadaiNo;
  }

  /**
   * 用途: setInspectDescription で選択状態や表示状態を更新する。
   * WHY: template/event からの更新入口を明示し、service/helper 境界を保つため。
   */
  setInspectDescription(work: any): any {
    return this.workAndBuhinDataService.buildManualWorkInspectDescription(work);
  }

  /**
   * 用途: chkRedundancyTopic で WorkAndBuhin の画面状態を処理する。
   * WHY: 既存 template/ref 互換を維持しながら責務境界を明示するため。
   */
  chkRedundancyTopic(target: any , i: number) {
    return WorkBuhinDisplay.buildBuhinTopicDisplayState({
      target,
      index: i,
      buhinContentLength: this.buhinContent.length,
      listManualBuhinName: this.listManualBuhinName,
      listManualBuhinFiltered: this.listManualBuhinFiltered
    }).shouldShowBuhinTopic;
  }

  /**
   * 用途: showKatashikiDialog で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showKatashikiDialog() {
    const katashikiParams = this.katashikiService.getKatashikiParams();
    const dialogActionState = WorkBuhinNisseiren.buildKatashikiDialogOpenActionState({
      katashikiParams,
      uketsukeExtendsId: this.uketsukeExtendsId,
      fallbackKatashiki: this.katashiki,
      fallbackEngineKatashiki: this.engineKatashiki
    });
    const dialogApplyEffectState = WorkBuhinNisseiren.buildKatashikiDialogOpenApplyEffectState(
      dialogActionState
    );
    if (dialogApplyEffectState.shouldOpen) {
      this.$refs.katashikiDialog.onOpen(
        dialogApplyEffectState.katashiki,
        dialogApplyEffectState.engineKatashiki
      );
    }
  }

  /**
   * 用途: showNisseirenJunseiSearchDialog で template の表示可否を判定する。
   * WHY: 表示条件を template から隠し、既存 UI 契約を維持するため。
   */
  showNisseirenJunseiSearchDialog(isJunseiOnly: boolean) {
    if (isJunseiOnly && this.isJunseiBuhinSearchDisabled()) {
      return;
    }
    const dialogActionState = WorkBuhinNisseiren.buildNisseirenJunseiSearchDialogOpenActionState(
      isJunseiOnly,
      this.isUseJunseiBuhin
    );
    const dialogApplyEffectState = WorkBuhinNisseiren.buildNisseirenJunseiSearchDialogOpenApplyEffectState(
      dialogActionState
    );
    if (dialogApplyEffectState.shouldOpen) {
      this.$refs.nisseirenJunseiSearchDialog.onOpen(
        dialogApplyEffectState.isJunseiOnly,
        dialogApplyEffectState.isUseJunseiBuhin
      );
    }
  }

  // 型式の詳細を検索する（作業部品ダイアログ表示時）
  /**
   * 用途: ※日整連･純正部品使用フラグが「0:使用しない」の場合、型式選択ダイアログは表示しないが、「検索結果が1件の場合は自動で設定する」までは通す。（過給機を表示するため）
   * WHY: 既存の関数説明を block comment 形式に揃えるため。
   */
  searchKatashiki() {
    WorkBuhinNisseirenApi.fetchCustomerCarKatashiki(this.reqService, this.uketsukeExtendsId)
      .then((customerKatashikiResult: any) => {
        if (customerKatashikiResult.data) {
          this.setKatashikiParams(
            WorkBuhinNisseiren.buildKatashikiParamsFromSaved(
              customerKatashikiResult.data,
              this.uketsukeExtendsId
            )
          );
        }
      });
    const initialActionState = WorkBuhinNisseiren.buildKatashikiSearchInitialActionState({
      katashiki: this.katashiki,
      engineKatashiki: this.engineKatashiki,
      isUseNisseiren: this.isUseNisseiren
    });
    const initialApplyEffectState = WorkBuhinNisseiren.buildKatashikiSearchInitialApplyEffectState(
      initialActionState
    );
    if (!initialApplyEffectState.shouldRequestKatashikiList) {
      // ストアの型式とエンジン型式が取得できない場合（リロード時など）は型式選択ダイアログを表示する
      if (initialApplyEffectState.shouldOpenDialogOnNextTick) {
        this.$nextTick(() => {
          this.$refs.katashikiDialog.onOpen(
            initialApplyEffectState.dialogKatashiki,
            initialApplyEffectState.dialogEngineKatashiki
          );
        });
      }
      return;
    }

    WorkBuhinNisseirenApi.fetchKatashikiList(
      this.reqService,
      this.katashiki,
      this.engineKatashiki,
      this.katashikiShiteiNo || "",
      this.ruibetsuKubunNo || ""
    )
    .then((searchResult: any) => {
      const resultActionState = WorkBuhinNisseiren.buildKatashikiSearchResultActionState({
        searchResult,
        isUseNisseiren: this.isUseNisseiren,
        katashiki: this.katashiki,
        engineKatashiki: this.engineKatashiki
      });
      const resultApplyEffectState = WorkBuhinNisseiren.buildKatashikiSearchResultApplyEffectState(
        resultActionState
      );
      if (resultApplyEffectState.shouldSetKatashikiParams) {
        // 検索結果が1件の場合は自動で設定する
        this.setKatashikiParams(resultApplyEffectState.katashikiParamsSource);
      }
      if (resultApplyEffectState.shouldOpenDialog) {
        this.$refs.katashikiDialog.onOpen(
          resultApplyEffectState.dialogKatashiki,
          resultApplyEffectState.dialogEngineKatashiki,
          resultApplyEffectState.dialogData
        );
      }
    });
  }

  /**
   * 用途: setKatashikiParams で選択状態や表示状態を更新する。
   * WHY: template/event からの更新入口を明示し、service/helper 境界を保つため。
   */
  setKatashikiParams(params: any) {
    const applyState = WorkBuhinNisseiren.buildKatashikiParamsApplyState(
      params,
      this.uketsukeExtendsId
    );
    const applyEffectState = WorkBuhinNisseiren.buildKatashikiParamsApplyEffectState(applyState);
    if (applyEffectState.shouldSetKatashikiParams) {
      this.katashikiService.setKatashikiParams(applyEffectState.katashikiParams);
    }
    this.hasKatashiki = applyEffectState.hasKatashiki;
    if (applyEffectState.shouldUpdateDisplayFields) {
      this.updateShowKatashiki();
      this.updateShowEngineKatashiki();
      this.updateShowKakyuki();
      this.updateShowModelNm();
    }
    if (applyEffectState.shouldUpdateKatashiki) {
      WorkBuhinNisseirenApi.updateKatashikiByParams(this.reqService, applyEffectState.katashikiParams);
    }
  }

  /**
   * 用途: 型式選択ダイアログの確定ボタン押下時
   * WHY: 既存の関数説明を block comment 形式に揃えるため。
   */
  onKatashikiSelected(params: any) {
    const selectedActionState = WorkBuhinNisseiren.buildKatashikiSelectedActionState(params);
    const selectedApplyEffectState = WorkBuhinNisseiren.buildKatashikiSelectedApplyEffectState(
      selectedActionState
    );
    if (selectedApplyEffectState.shouldSetKatashikiParams) {
      this.setKatashikiParams(selectedApplyEffectState.katashikiParamsSource);
    }
    if (selectedApplyEffectState.shouldLoadNisseirenJunsei) {
      this.getNisseirenJunseiByKatashiki();
    }
  }

  /**
   * 用途: onNisseirenJunseiSelected で UI event や親 event を受けて処理を開始する。
   * WHY: 画面操作の入口と helper/service 呼び出しを明確に分けるため。
   */
  onNisseirenJunseiSelected(obj: any) {

    const selectedActionState = WorkBuhinNisseiren.buildNisseirenJunseiSelectedActionState({
      manualSeibiList: this.workAndBuhinDataService.getManualSeibiList(),
      filteredNisseirenWork: obj.filteredNisseirenWork,
      filteredJunseiBuhin: obj.filteredJunseiBuhin,
      isUseJunseiBuhin: this.isUseJunseiBuhin,
      activeWorkIndex: this.activeWorkIndex
    });
    const selectedEffectState = WorkBuhinNisseiren.buildNisseirenJunseiSelectedApplyEffectState({
      actionState: selectedActionState,
      filteredNisseirenWork: obj.filteredNisseirenWork,
      filteredJunseiBuhin: obj.filteredJunseiBuhin
    });
    if (selectedEffectState.shouldSetFoundNisseirenWork) {
      this.setFoundNisseirenWork(selectedEffectState.foundNisseirenWork);
    }
    const selectionState = selectedEffectState.manualWorkSelectionState;
    if (selectedEffectState.shouldSelectManualWork && selectionState) {
      this.isManualWork = selectionState.isManualWork;
      this.activeWorkIndex = selectionState.activeWorkIndex;
      this.activeSeibiId = selectionState.activeSeibiId;
      this.activeSeibiNm = selectionState.activeSeibiNm;
      this.initListSelectedBuhin(selectionState.work);
    }
    if (selectedEffectState.shouldScrollManualWork) {
      this.scrollTobottom(selectedEffectState.manualWorkScrollTargetId);
    }

    if (!selectedEffectState.shouldUseJunseiBuhin) {
      return;
    }
    if (selectedEffectState.shouldSetFoundJunseiBuhin) {
      this.setFoundJunseiBuhin(selectedEffectState.foundJunseiBuhin);
    }
    if (selectedEffectState.shouldApplySelectedJunseiBuhin) {
      const work = this.getWork();
      if (selectedEffectState.shouldSetWorkBuhinSelectedDone) {
        work.buhinSelected = STATUS_SELECT_WORK_BUHIN.Done;
      }
      if (selectedEffectState.shouldSetIsChange) {
        this.isChange = selectedEffectState.isChange;
      }
      if (selectedEffectState.shouldAppendSelectedJunseiBuhin) {
        WorkBuhinManual.appendUniqueSelectedJunseiBuhin(
          this.listSelectedBuhin,
          selectedEffectState.selectedJunseiBuhinToAppend
        );
      }
    }
    if (selectedEffectState.shouldScrollJunseiBuhin) {
      this.scrollTobottom(selectedEffectState.junseiBuhinScrollTargetId);
    }
    if (selectedEffectState.shouldCheckDisabledBtnConfirm) {
      this.checkDisabledBtnConfirm();
    }

    if (selectedEffectState.shouldSelectJunseiTab) {
      this.onSelectJunseiTab();
    }
  }

  /**
   * 用途: setFoundNisseirenWork で選択状態や表示状態を更新する。
   * WHY: template/event からの更新入口を明示し、service/helper 境界を保つため。
   */
  setFoundNisseirenWork(items: any) {
    const foundState = WorkBuhinNisseiren.buildFoundNisseirenWorkState({
      manualSeibiList: this.workAndBuhinDataService.getManualSeibiList(),
      items
    });
    const foundEffectState = WorkBuhinNisseiren.buildFoundNisseirenWorkApplyEffectState(foundState);
    if (foundEffectState.shouldApply) {
      this.workAndBuhinDataService.setManualSeibiList(foundEffectState.manualSeibiList);
    }
  }

  /**
   * 用途: setFoundJunseiBuhin で選択状態や表示状態を更新する。
   * WHY: template/event からの更新入口を明示し、service/helper 境界を保つため。
   */
  setFoundJunseiBuhin(items: any) {
    const foundState = WorkBuhinManual.buildFoundJunseiBuhinState({
      manualBuhinList: this.listManualBuhin,
      items
    });
    const foundEffectState = WorkBuhinManual.buildFoundJunseiBuhinApplyEffectState(foundState);
    if (!foundEffectState.shouldApply) {
      return;
    }
  }

  /**
   * 用途: 画像連携対象の inspect 情報を取得する。
   * WHY: API、loading、socket 反映の副作用境界を component に残すため。
   */
  async getExtendsImageInspect() {
    const loadActionState = this.workAndBuhinDataService
      .buildExtendsImageInspectLoadActionState(this.isCanExtendsImage);
    if (!loadActionState.shouldLoad) {
      // プロパティが不足の場合は実行しない（partSelection.vueの初期化前など）
      return;
    }
    const extendsImageInspect = await this.extendsImageService.getExtendsImageInspectByInspectId(
      loadActionState.sknUketsukeInspectId
    );
    const loadEffectState = WorkBuhinExtendsImage.buildExtendsImageInspectLoadApplyEffectState({
      actionState: loadActionState,
      extendsImageInspect
    });
    if (loadEffectState.shouldApplyInspect) {
      this.extendsImageInspect = loadEffectState.extendsImageInspect;
    }
    if (loadEffectState.shouldConnectSocket) {
      this.extendsImageService.connectSocket(this.extendsImageSocketCallback);
    }
  }
  /**
   * 用途: 画像連携 socket 更新を現在の inspect に反映する。
   * WHY: 外部更新と画面 state の同期箇所を明示するため。
   */
  extendsImageSocketCallback(updatedList: ExtendsImageInspectVO[]) {
    // この画面で開いている点検の画像が更新された場合のみ反映し、それ以外の点検の画像の更新は無視する（都度API実行で取得するため）
    const socketActionState = WorkBuhinExtendsImage.buildExtendsImageSocketApplyActionState({
      currentInspect: this.extendsImageInspect,
      updatedList
    });
    const socketEffectState = WorkBuhinExtendsImage.buildExtendsImageSocketApplyEffectState(socketActionState);
    if (socketEffectState.shouldShowMessage) {
      this.$message(socketEffectState.messagePayload);
    }
    if (socketEffectState.shouldApplyInspect) {
      this.extendsImageInspect = socketEffectState.extendsImageInspect;
    }
  }
  /**
   * 用途: get hasImage で選択状態や活性条件を判定する。
   * WHY: 業務条件を template/event から分離して読みやすくするため。
   */
  get hasImage(): boolean {
    return WorkBuhinDisplay.buildBuhinImageDisplayState({
      isCanExtendsImage: this.isCanExtendsImage,
      extendsImageInspect: this.extendsImageInspect
    }).hasImage;
  }
}


